(function ($, Drupal, drupalSettings, once) {
  'use strict';

  var activeIcon;

  /* INSTATIATE OBJECT FIT FOR PATHWAYS IMAGE */
  objectFitImages('.route-location-item__image', {watchMQ: true}); // eslint-disable-line no-undef

  // Disable for usage of polyfill.
  /* eslint-disable */
  (function templatePolyfill(d) {
    if ('content' in d.createElement('template')) {
      return false;
    }

    var qPlates = d.getElementsByTagName('template');
    var plateLen = qPlates.length;
    var elPlate;
    var qContent;
    var contentLen;
    var docContent;

    for (var x = 0; x < plateLen; ++x) {
      elPlate = qPlates[x];
      qContent = elPlate.childNodes;
      contentLen = qContent.length;
      docContent = d.createDocumentFragment();

      while (qContent[0]) {
        docContent.appendChild(qContent[0]);
      }

      elPlate.content = docContent;
    }
  })(document);
  /* eslint-enable */

  $.urlParam = function (name) {
    var results = new RegExp('[?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results !== null) {
      results[1] = results[1].replace('+', ' ');
      return results[1] ? decodeURIComponent(results[1]) : null;
    }
    return null;
  };

  /**
   * Gets a deeply nested value in an object. Returns default value if unset.
   *
   * @function
   * @param {object} obj
   *   The object which contains the value you want to change/set.
   * @param {array} parents
   *   The array representation of path to the value you want to change/set.
   * @param {*} defaultValue
   *   The default value to return if the nested object property is unset.
   *
   * @return {*}
   *   The nested object property if set. The defaultValue otherwise.
   */
  function getNestedValue(obj, parents, defaultValue) {
    var length = parents.length;

    for (var i = 0; i < length; i++) {
      if (!obj || typeof obj !== 'object' || typeof obj[parents[i]] === 'undefined' || obj[parents[i]] === null) {
        return defaultValue;
      }
      obj = obj[parents[i]];
    }

    return obj;
  }

  /**
   * Dynamically sets a deeply nested value in an object.
   *
   * @function
   * @param {object} obj
   *   The object which contains the value you want to change/set.
   * @param {array} parents
   *   The array representation of path to the value you want to change/set.
   * @param {*} value
   *   The value you want to set it to.
   */
  function setNestedValue(obj, parents, value) {
    var level = 0;
    parents.reduce(function (a, b) {
      level++;
      if (typeof a[b] === 'undefined' && level !== parents.length) {
        a[b] = {};
        return a[b];
      }

      if (level === parents.length) {
        a[b] = value;
        return value;
      }
      else {
        return a[b];
      }

    }, obj);
  }

  /**
   * Calculates the distance in km from one geolocation to another.
   *
   * @param {number} lat1
   *   Latitude of point 1.
   * @param {number} lon1
   *   Longitude of point 1.
   * @param {number} lat2
   *   Latitude of point 2.
   * @param {number} lon2
   *   Longitude of point 2.
   *
   * @return {number}
   *   The distance in km.
   */
  function calculateDistance(lat1, lon1, lat2, lon2) {
    var R = 6371; // km
    var dLat = toRad(lat2 - lat1);
    var dLon = toRad(lon2 - lon1);
    lat1 = toRad(lat1);
    lat2 = toRad(lat2);

    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;

    return d;
  }

  /**
   * Converts a number to a radian value.
   *
   * @param {number} Value
   *   The number.
   *
   * @return {number}
   *   The radian version of the value.
   */
  function toRad(Value) {
    return Value * Math.PI / 180;
  }

  Drupal.behaviors.componentRouteMap = {
    colors: {
      green: '#3D9C0E',
      greenAccent: '#7AB45E',
      grey: '#272D30'
    },
    routeGeolocations: {
      directions: {
        bristol: {lat: 36.5319241, lng: -82.3494935},
        chattanooga: {lat: 35.0982754, lng: -85.3087306},
        knoxville: {lat: 35.9584416, lng: -83.9951221},
        memphis: {lat: 35.1291054, lng: -90.1108699},
        nashville: {lat: 36.1865589, lng: -86.9253283},
        smokies: {lat: 35.727245, lng: -83.5330358},

        // Deprecated
        middle: {lat: 35.842732, lng: -86.406735},
        nw: {lat: 36.462962, lng: -89.451788},
        n: {lat: 36.621240, lng: -85.767652},
        ne: {lat: 36.586377, lng: -81.708587},
        e: {lat: 35.786185, lng: -82.998432},
        se: {lat: 35.023884, lng: -84.358282},
        s: {lat: 35.020952, lng: -87.187839},
        sw: {lat: 34.996085, lng: -90.309005},
        w: {lat: 35.726370, lng: -89.923687}
      }
    },
    routeLocations: {},
    routeLocationsLatLng: [],
    routeCountTotal: 0,
    routeMapMarkers: {},
    routeMapMarkersVisual: {},
    routeMaps: {},
    routeMapSettings: {},
    /* eslint-disable */
    routeMapStyles:[{stylers:[{saturation:-85}]},{featureType:'administrative.locality',stylers:[{visibility:'simplified'}]},{featureType:'administrative.province',stylers:[{visibility:'on'}]},{featureType:'landscape.man_made',stylers:[{visibility:'off'}]},{featureType:'poi',stylers:[{visibility:'off'}]},{featureType:'road.arterial',stylers:[{visibility:'off'}]},{featureType:'road.highway',stylers:[{visibility:'simplified'}]},{featureType:'road.highway',elementType:'labels',stylers:[{visibility:'off'}]},{featureType:'road.highway.controlled_access',stylers:[{visibility:'off'}]},{featureType:'road.local',stylers:[{visibility:'off'}]},{featureType:'water',stylers:[{visibility:'off'}]}],
    routeMapTimeout: {},
    worldBoundaries: [{lat:-85.1054596961173,lng:0},{lat:-85.1054596961173,lng:180},{lat:85.1054596961173,lng:180},{lat:85.1054596961173,lng:-180},{lat:-85.1054596961173,lng:-180}],
    stateBoundaries: [{lat:36.1569600001855,lng:-82.2220640004316},{lat:36.1508379997828,lng:-82.2242749995859},{lat:36.1445879996805,lng:-82.2295369999403},{lat:36.1371250001759,lng:-82.2418829996408},{lat:36.1312489999762,lng:-82.2450970001492},{lat:36.1320510000648,lng:-82.2510719996327},{lat:36.1360580002518,lng:-82.2543279999739},{lat:36.133532999915,lng:-82.2603040001807},{lat:36.1272969997265,lng:-82.2639250003948},{lat:36.1269669998935,lng:-82.2664129995586},{lat:36.1293170001274,lng:-82.2734480002976},{lat:36.1290940000562,lng:-82.2800119999601},{lat:36.1357269997909,lng:-82.2885719995901},{lat:36.1354750000425,lng:-82.2904560003029},{lat:36.1314649997299,lng:-82.3024809996131},{lat:36.1197300002791,lng:-82.3205310004322},{lat:36.1201809997017,lng:-82.3233919998648},{lat:36.1146240002189,lng:-82.3363979998894},{lat:36.1164860000421,lng:-82.3526460000115},{lat:36.1075159997762,lng:-82.3645409996254},{lat:36.1058620002119,lng:-82.3752169997717},{lat:36.1032530000622,lng:-82.3787259998329},{lat:36.0993470000261,lng:-82.3804749999281},{lat:36.0970969998263,lng:-82.3892179998562},{lat:36.0830189996775,lng:-82.4097979996718},{lat:36.0077240000905,lng:-82.4605830002114},{lat:36.0028870002634,lng:-82.4704159997355},{lat:35.9982209996458,lng:-82.4759400000307},{lat:35.9980290001966,lng:-82.4815909996491},{lat:35.9933009998416,lng:-82.4841699999478},{lat:35.982440999809,lng:-82.4999639996101},{lat:35.9821580000063,lng:-82.5033239997084},{lat:35.9775469998288,lng:-82.5051840001317},{lat:35.9772920003056,lng:-82.510298000348},{lat:35.9753009998189,lng:-82.5128490001592},{lat:35.9758250000885,lng:-82.5170770000957},{lat:35.9740120001698,lng:-82.5221209999919},{lat:35.9710550003443,lng:-82.5250309998283},{lat:35.9722259996839,lng:-82.5306930002157},{lat:35.964049000069,lng:-82.5496860003178},{lat:35.9538729999751,lng:-82.5579880002049},{lat:35.958719999857,lng:-82.5761689996469},{lat:35.9643340002904,lng:-82.5777980000916},{lat:35.9652479996434,lng:-82.5804619998807},{lat:35.9662889998594,lng:-82.5919819995758},{lat:35.9645940003478,lng:-82.600106000086},{lat:35.9672029998485,lng:-82.6107029996914},{lat:35.9743800003559,lng:-82.6109389996929},{lat:35.9874630001985,lng:-82.6044129996652},{lat:35.9923599996922,lng:-82.6071280004063},{lat:35.9936060002316,lng:-82.6128970000255},{lat:36.0020459997009,lng:-82.6149280001531},{lat:36.004917000324,lng:-82.6138250001382},{lat:36.0104300001368,lng:-82.6068759996129},{lat:36.0110379997546,lng:-82.6094449998658},{lat:36.015753999796,lng:-82.6077610000679},{lat:36.0177560000545,lng:-82.6028390003705},{lat:36.0233709999938,lng:-82.6029230000361},{lat:36.0315739997978,lng:-82.5909949999119},{lat:36.0355679999027,lng:-82.5914469998235},{lat:36.0360540003053,lng:-82.6016590003627},{lat:36.0386530000219,lng:-82.6018760000977},{lat:36.0444109999574,lng:-82.6086590000433},{lat:36.0469160003379,lng:-82.6183839996125},{lat:36.0537679999817,lng:-82.6170420001213},{lat:36.055909999759,lng:-82.6179540003405},{lat:36.0640209997607,lng:-82.632054999984},{lat:36.0659109999854,lng:-82.632608000178},{lat:36.0658200002378,lng:-82.6372300002998},{lat:36.0573680001923,lng:-82.6515329996097},{lat:36.0571170003216,lng:-82.6592679999575},{lat:36.0530359997409,lng:-82.6663460003542},{lat:36.0529760002051,lng:-82.6705619996968},{lat:36.0488329998641,lng:-82.6748509997326},{lat:36.045794999932,lng:-82.6840730002348},{lat:36.0414210001059,lng:-82.6859870001865},{lat:36.038157000048,lng:-82.689585999761},{lat:36.0357830001682,lng:-82.6972240000244},{lat:36.0342000001022,lng:-82.6981899997719},{lat:36.0343590002989,lng:-82.7012279996549},{lat:36.032649999968,lng:-82.7017959999174},{lat:36.0297209998395,lng:-82.7086399999625},{lat:36.028641999946,lng:-82.7151409998758},{lat:36.0224100001534,lng:-82.7164699998465},{lat:36.0181610002616,lng:-82.7254639998447},{lat:36.0149789997372,lng:-82.7391169997747},{lat:36.0121320002407,lng:-82.740284000262},{lat:36.0088709997965,lng:-82.7507870001559},{lat:36.0059809997678,lng:-82.7502210004415},{lat:36.0062019997063,lng:-82.7525680000382},{lat:36.0043459998466,lng:-82.7545509995869},{lat:36.0048439996637,lng:-82.7625699996168},{lat:36.0007040000656,lng:-82.7720730003264},{lat:36.0010510000934,lng:-82.7757580001146},{lat:35.9922889999817,lng:-82.779213999574},{lat:35.9885390000532,lng:-82.7852759999945},{lat:35.9818839999032,lng:-82.7844759999283},{lat:35.9778409997531,lng:-82.7856900002713},{lat:35.9742970000509,lng:-82.7815870000083},{lat:35.9740579998325,lng:-82.776504999579},{lat:35.9718289998636,lng:-82.775086000095},{lat:35.9667729997683,lng:-82.7780379997642},{lat:35.9624830000989,lng:-82.785043000366},{lat:35.9520129999118,lng:-82.787559999842},{lat:35.9509969996709,lng:-82.7913750002249},{lat:35.9469329996773,lng:-82.7945450003524},{lat:35.9446609997477,lng:-82.7997270003408},{lat:35.9377580003196,lng:-82.8061679999797},{lat:35.9295709998226,lng:-82.802674999812},{lat:35.9271369998976,lng:-82.8050850000563},{lat:35.9255469996926,lng:-82.8150859998099},{lat:35.9218300002738,lng:-82.8219480002966},{lat:35.932412999799,lng:-82.8280979996823},{lat:35.932813000309,lng:-82.8324059999847},{lat:35.9355980002637,lng:-82.8334720001897},{lat:35.9372709998468,lng:-82.8386380002846},{lat:35.9417409998771,lng:-82.8411160003009},{lat:35.9419869998562,lng:-82.844545999821},{lat:35.9461690001553,lng:-82.8460370001734},{lat:35.9493439997396,lng:-82.8517329999977},{lat:35.947479000201,lng:-82.86064699963},{lat:35.9528299999448,lng:-82.8742929998872},{lat:35.950116999805,lng:-82.8782229998978},{lat:35.9483439998283,lng:-82.8889860000828},{lat:35.9450029997698,lng:-82.8926619996502},{lat:35.9452300001963,lng:-82.8981819997474},{lat:35.9378519998115,lng:-82.901783999695},{lat:35.9298759998567,lng:-82.8988859995541},{lat:35.9269600001715,lng:-82.90181999968},{lat:35.9261969998379,lng:-82.9059470002324},{lat:35.9275050002667,lng:-82.9106210002327},{lat:35.9295940002334,lng:-82.9121950004258},{lat:35.9287980002758,lng:-82.919935999723},{lat:35.9258920001609,lng:-82.9192410001371},{lat:35.9242609998746,lng:-82.9135350002671},{lat:35.9168080002293,lng:-82.9116239997902},{lat:35.9151500000882,lng:-82.9143870002118},{lat:35.9109680001941,lng:-82.9097340001279},{lat:35.911313999911,lng:-82.9080319998883},{lat:35.9074290002239,lng:-82.9069799999271},{lat:35.9042040000843,lng:-82.9081089998812},{lat:35.8927909998834,lng:-82.9010430000783},{lat:35.8839080003383,lng:-82.9068250001164},{lat:35.8804579997705,lng:-82.9036270003999},{lat:35.8812580001421,lng:-82.8982860004028},{lat:35.879543999665,lng:-82.896081000198},{lat:35.8729089998361,lng:-82.9008909997424},{lat:35.8701800003459,lng:-82.9065549997796},{lat:35.8685729999146,lng:-82.9107740003936},{lat:35.8681779996863,lng:-82.9208310002237},{lat:35.863104999974,lng:-82.9214320000983},{lat:35.8592720000034,lng:-82.918212999567},{lat:35.8509450001616,lng:-82.921033999715},{lat:35.8416629996654,lng:-82.9163429999963},{lat:35.8393849997029,lng:-82.9202110000826},{lat:35.8366619996602,lng:-82.9340699998769},{lat:35.8305289999663,lng:-82.9333429996056},{lat:35.8255169998872,lng:-82.9360349998822},{lat:35.8243780002596,lng:-82.9458470003883},{lat:35.8177840000278,lng:-82.9481959996348},{lat:35.8166079998539,lng:-82.9517640001455},{lat:35.8003659996813,lng:-82.9618109999299},{lat:35.7949240000207,lng:-82.9628999997011},{lat:35.7909590000575,lng:-82.9617540000285},{lat:35.7899939996495,lng:-82.9630250002729},{lat:35.7896350001499,lng:-82.9696990004386},{lat:35.7780929996919,lng:-82.9839249997556},{lat:35.7730819996474,lng:-82.9959890003222},{lat:35.7737790002321,lng:-83.0012919997861},{lat:35.778496000178,lng:-83.005988000426},{lat:35.7787449997485,lng:-83.0109029995524},{lat:35.7820490000816,lng:-83.0160250001647},{lat:35.7804019996848,lng:-83.0203479996374},{lat:35.7834199998565,lng:-83.0238860000108},{lat:35.7875039998409,lng:-83.0360419997406},{lat:35.7854070000851,lng:-83.043062000411},{lat:35.7897049998893,lng:-83.0528210003153},{lat:35.7869139996947,lng:-83.0637469998086},{lat:35.7901369998734,lng:-83.0742010001971},{lat:35.7896749999045,lng:-83.0785029997534},{lat:35.785843999866,lng:-83.0852649997827},{lat:35.7814910001452,lng:-83.0893019999234},{lat:35.7796000002225,lng:-83.0945800001713},{lat:35.7763509996472,lng:-83.096754000414},{lat:35.7743769997981,lng:-83.1046029996662},{lat:35.7706239998515,lng:-83.111204000037},{lat:35.7697839999025,lng:-83.1182389998777},{lat:35.7664309999274,lng:-83.1206080001141},{lat:35.7680859998497,lng:-83.1274639998547},{lat:35.765139000327,lng:-83.1364710002717},{lat:35.7646509997365,lng:-83.1595850001801},{lat:35.7596800000026,lng:-83.164971000383},{lat:35.7539880003643,lng:-83.1647899997347},{lat:35.750757999955,lng:-83.1683230000853},{lat:35.7460300000827,lng:-83.1702849997176},{lat:35.7443829996447,lng:-83.1777919995614},{lat:35.7300970002282,lng:-83.1859060000259},{lat:35.7252529999631,lng:-83.1977420000885},{lat:35.7261910000828,lng:-83.207382999992},{lat:35.7241130000679,lng:-83.2141960000749},{lat:35.7259580002841,lng:-83.2180819997046},{lat:35.7268560001545,lng:-83.2408270004404},{lat:35.7225200002819,lng:-83.2432490003802},{lat:35.7197519998367,lng:-83.2515069998864},{lat:35.7152439998862,lng:-83.2553559997061},{lat:35.7089739996608,lng:-83.2515679999857},{lat:35.7051200000819,lng:-83.2574300003897},{lat:35.6954449997346,lng:-83.2543249996613},{lat:35.6939690003208,lng:-83.2576119999646},{lat:35.6903709999157,lng:-83.2592909997396},{lat:35.686826999664,lng:-83.2706799999135},{lat:35.6831679999683,lng:-83.2711660001603},{lat:35.6790759998753,lng:-83.274466999809},{lat:35.6776990003546,lng:-83.2813419998161},{lat:35.6744629998392,lng:-83.2839889998868},{lat:35.6734980003446,lng:-83.2903049998523},{lat:35.6618790001046,lng:-83.2935450002999},{lat:35.6572550000173,lng:-83.2982440004145},{lat:35.6546120002996,lng:-83.3120760004446},{lat:35.6630539999452,lng:-83.3216160000658},{lat:35.6656619997648,lng:-83.3346560004256},{lat:35.6636339997535,lng:-83.3387210001554},{lat:35.664589000123,lng:-83.3410639995542},{lat:35.6612090000203,lng:-83.3450069999836},{lat:35.6605419999101,lng:-83.3508159997859},{lat:35.6543050003247,lng:-83.3559690003603},{lat:35.6507569997494,lng:-83.3559330003752},{lat:35.6469979998269,lng:-83.3582730002993},{lat:35.6410279999606,lng:-83.3660560003276},{lat:35.6378410000402,lng:-83.367797000027},{lat:35.6391629999912,lng:-83.3718280003199},{lat:35.6345620002795,lng:-83.3780870003839},{lat:35.6336220002843,lng:-83.388725999822},{lat:35.6265640000729,lng:-83.3916709998185},{lat:35.6228660002175,lng:-83.3961470003504},{lat:35.6205119998453,lng:-83.4055329999859},{lat:35.6145040000862,lng:-83.4150340001473},{lat:35.6135169996737,lng:-83.4201349999448},{lat:35.6110490002305,lng:-83.4220380000259},{lat:35.6099900000301,lng:-83.4323030002685},{lat:35.6117469997808,lng:-83.4456759998159},{lat:35.603527999945,lng:-83.4516479998248},{lat:35.6020220003578,lng:-83.4550110002961},{lat:35.597194000133,lng:-83.4565889997887},{lat:35.5952860001324,lng:-83.4614519999349},{lat:35.5925700002976,lng:-83.4626920002171},{lat:35.59026800024,lng:-83.4712960002281},{lat:35.5862520001347,lng:-83.4728539996293},{lat:35.5832179999604,lng:-83.4790719996854},{lat:35.579190000318,lng:-83.4786309996444},{lat:35.568471000288,lng:-83.4853569996887},{lat:35.5668300000051,lng:-83.4933170001673},{lat:35.5629319997572,lng:-83.4984029998963},{lat:35.5624380000337,lng:-83.5165640001451},{lat:35.5655920002232,lng:-83.5212950000468},{lat:35.5644850003178,lng:-83.5319839997137},{lat:35.5658650000671,lng:-83.540716999596},{lat:35.5634539996737,lng:-83.551042999938},{lat:35.56609099989,lng:-83.5649789997251},{lat:35.5642940001959,lng:-83.5665250003291},{lat:35.5653810002875,lng:-83.5726630000193},{lat:35.5626980001524,lng:-83.5843740004084},{lat:35.5749990001673,lng:-83.5961169996863},{lat:35.5749999996951,lng:-83.5983019997996},{lat:35.578919000269,lng:-83.6017740000509},{lat:35.5800150002357,lng:-83.6083360000636},{lat:35.5722540000082,lng:-83.618571000169},{lat:35.5726969998469,lng:-83.621307999753},{lat:35.5681710000483,lng:-83.6293130004375},{lat:35.5706719999426,lng:-83.633861999866},{lat:35.5680959998129,lng:-83.635328999929},{lat:35.566165000172,lng:-83.6401300001509},{lat:35.5659129996625,lng:-83.6451520003057},{lat:35.5700130003087,lng:-83.6560140002249},{lat:35.5683389998825,lng:-83.6610020000445},{lat:35.5697560000524,lng:-83.6638049997508},{lat:35.5703509998401,lng:-83.6797569995969},{lat:35.568197000211,lng:-83.6876969999841},{lat:35.5703220001567,lng:-83.6956099997088},{lat:35.5674760000491,lng:-83.701241999959},{lat:35.5685509996751,lng:-83.7069899996618},{lat:35.5664020002499,lng:-83.712474999599},{lat:35.5641829997131,lng:-83.7140069999592},{lat:35.5622960001355,lng:-83.7227719996286},{lat:35.5655209998116,lng:-83.7361369996785},{lat:35.5603079999893,lng:-83.7471579996063},{lat:35.5646149997196,lng:-83.7549919996883},{lat:35.5625729997087,lng:-83.7595510000608},{lat:35.5613900001209,lng:-83.7718890002638},{lat:35.5574319996751,lng:-83.7726659998654},{lat:35.550634000228,lng:-83.7801819999301},{lat:35.5456490001452,lng:-83.7946459997968},{lat:35.5416410001327,lng:-83.7987850000448},{lat:35.5414869998627,lng:-83.8028039997439},{lat:35.5370930001736,lng:-83.8080379996108},{lat:35.5329960000851,lng:-83.8098930000113},{lat:35.5256519999357,lng:-83.8204670000504},{lat:35.5245739999597,lng:-83.8321430002794},{lat:35.5186319996514,lng:-83.8491439997137},{lat:35.5215730003592,lng:-83.8571810001853},{lat:35.5200080003031,lng:-83.8680690000437},{lat:35.5208559999155,lng:-83.8732359999635},{lat:35.5190499999133,lng:-83.8798480002049},{lat:35.5046630002798,lng:-83.8899269997764},{lat:35.4965520001095,lng:-83.9014659997381},{lat:35.4930310001029,lng:-83.9003650002713},{lat:35.488689000283,lng:-83.9057809997132},{lat:35.4760680003249,lng:-83.9118749999207},{lat:35.4736490001581,lng:-83.9166209998911},{lat:35.4743110000888,lng:-83.9241410001537},{lat:35.4715530000516,lng:-83.9367229998558},{lat:35.4673119996491,lng:-83.9419700001415},{lat:35.4643980003,lng:-83.9428789999876},{lat:35.4609410001797,lng:-83.9496490004128},{lat:35.4605429997792,lng:-83.9529640003052},{lat:35.4636450001392,lng:-83.9557720000344},{lat:35.46413799992,lng:-83.9610800004195},{lat:35.4566159999074,lng:-83.9627809999358},{lat:35.4562379997254,lng:-83.9656930003204},{lat:35.4541119999876,lng:-83.9646239997424},{lat:35.4548489998151,lng:-83.9718550003},{lat:35.4530070001868,lng:-83.9710960002417},{lat:35.4527619999736,lng:-83.9732889998527},{lat:35.4472979996983,lng:-83.9726550003662},{lat:35.4480110001752,lng:-83.9751280003596},{lat:35.4465370002389,lng:-83.9760940001071},{lat:35.4482600002535,lng:-83.9797570001541},{lat:35.4401499997799,lng:-83.9844329998042},{lat:35.4409209998836,lng:-83.9879829998732},{lat:35.4390870000806,lng:-83.9889190003818},{lat:35.4405229999898,lng:-83.9920040001204},{lat:35.435180000266,lng:-83.9947120002905},{lat:35.43389300011,lng:-83.99959299998},{lat:35.4312409999778,lng:-83.9993899995904},{lat:35.4307319999633,lng:-83.9979550002128},{lat:35.423390999799,lng:-84.001280000151},{lat:35.4123489998023,lng:-84.0144409999863},{lat:35.4115810002634,lng:-84.0234249999388},{lat:35.399995999958,lng:-84.0187119995805},{lat:35.3978849997773,lng:-84.0138669998759},{lat:35.3921919999597,lng:-84.0125129997909},{lat:35.3905739996774,lng:-84.0082220001053},{lat:35.3846010000797,lng:-84.0113960004307},{lat:35.3787660001575,lng:-84.008300999748},{lat:35.3728179999505,lng:-84.0087419997889},{lat:35.3716489998225,lng:-84.0073939995517},{lat:35.3649809999023,lng:-84.0150569999294},{lat:35.3543119999196,lng:-84.0233339997022},{lat:35.3511799997992,lng:-84.0380829999743},{lat:35.3482080001003,lng:-84.0388810003906},{lat:35.3432759998003,lng:-84.0340009996277},{lat:35.3376580001166,lng:-84.0361949999619},{lat:35.3365290003663,lng:-84.0314740001059},{lat:35.3330999999924,lng:-84.0292570002055},{lat:35.3225570001484,lng:-84.0344919998974},{lat:35.3132149999869,lng:-84.0358839996173},{lat:35.3111830001383,lng:-84.0341150003289},{lat:35.3096719998487,lng:-84.0269690001601},{lat:35.3063209997903,lng:-84.0262979999653},{lat:35.3014009999068,lng:-84.0214189999256},{lat:35.2963079999451,lng:-84.0233780000831},{lat:35.2884180003024,lng:-84.0362390003428},{lat:35.2796000003372,lng:-84.0408170000836},{lat:35.2742499999367,lng:-84.0468870000018},{lat:35.2733379997029,lng:-84.0510079998081},{lat:35.2701890001571,lng:-84.0525359999704},{lat:35.2612520001685,lng:-84.0808519999587},{lat:35.2562880000158,lng:-84.0825299999088},{lat:35.2493740002672,lng:-84.0923180001255},{lat:35.2475979998145,lng:-84.0975040003118},{lat:35.2483650001068,lng:-84.1025630002766},{lat:35.2514910003042,lng:-84.1064770003937},{lat:35.2489810000393,lng:-84.1135540000672},{lat:35.2520489999703,lng:-84.119926999934},{lat:35.2498710000527,lng:-84.1252200002505},{lat:35.2463049996691,lng:-84.1267190001005},{lat:35.2421209997932,lng:-84.1257209996676},{lat:35.2407700003655,lng:-84.1271109997377},{lat:35.2423769998669,lng:-84.133619000222},{lat:35.2460969999338,lng:-84.1394000004351},{lat:35.2468639997527,lng:-84.1477609998735},{lat:35.2457199999248,lng:-84.1592289996901},{lat:35.2435229998624,lng:-84.1614609996591},{lat:35.246459999728,lng:-84.1700260002102},{lat:35.2406380000367,lng:-84.1785389999846},{lat:35.2399959999762,lng:-84.1835129995605},{lat:35.2402170002096,lng:-84.188957000388},{lat:35.2447790002487,lng:-84.1933750002953},{lat:35.2438540002552,lng:-84.1995199996582},{lat:35.2552910002899,lng:-84.2029819998636},{lat:35.2656210001094,lng:-84.2113950000788},{lat:35.2689849998104,lng:-84.2241220004442},{lat:35.2642450001985,lng:-84.232503999799},{lat:35.2534869999902,lng:-84.2425210003445},{lat:35.2507199999477,lng:-84.2508319995541},{lat:35.2456629997203,lng:-84.2583710000833},{lat:35.2418329996614,lng:-84.2604089998835},{lat:35.2342039998267,lng:-84.275908999818},{lat:35.2264590002573,lng:-84.2832969998361},{lat:35.2243459999896,lng:-84.2881030000809},{lat:35.2254319997533,lng:-84.2902139996761},{lat:34.9884079997862,lng:-84.3218210001656},{lat:34.9882430001005,lng:-84.8915150002736},{lat:34.9829720000974,lng:-85.4667129996869},{lat:34.9881309997765,lng:-85.824023000088},{lat:34.9917379996971,lng:-86.3749659999432},{lat:34.9904799997232,lng:-86.4681150004112},{lat:34.9923390000331,lng:-86.6695640004039},{lat:34.9919569999865,lng:-86.8621470004449},{lat:35.0026679998649,lng:-87.4188599997442},{lat:35.00802799984,lng:-88.2029589996408},{lat:34.9956339997679,lng:-88.200063999873},{lat:34.9959200001214,lng:-88.8939009995718},{lat:34.9937539999593,lng:-89.4349540000014},{lat:34.9952930002761,lng:-89.6442820002819},{lat:34.9947140001529,lng:-90.1483610002856},{lat:34.9956940002954,lng:-90.3092890001565},{lat:35.0008659997947,lng:-90.3100580002605},{lat:35.0097490003089,lng:-90.3098719995893},{lat:35.0181939996421,lng:-90.3068970003539},{lat:35.0378930001134,lng:-90.297295999735},{lat:35.041792999819,lng:-90.2919959997458},{lat:35.0402939997739,lng:-90.2652930003086},{lat:35.0363939998636,lng:-90.2623919997947},{lat:35.0344940002398,lng:-90.2564900001061},{lat:35.031319999692,lng:-90.2306100003013},{lat:35.025795000087,lng:-90.2143820002707},{lat:35.0265460003647,lng:-90.2093969999258},{lat:35.0328929999985,lng:-90.2000449997273},{lat:35.0377880000063,lng:-90.1958169997908},{lat:35.0483810002563,lng:-90.1972210001045},{lat:35.0602079999161,lng:-90.1958729998673},{lat:35.0914010000451,lng:-90.1813870002592},{lat:35.1120880002499,lng:-90.1768429999553},{lat:35.1180730001042,lng:-90.173603000406},{lat:35.1288299999091,lng:-90.1600580004311},{lat:35.1350909998266,lng:-90.1427940003328},{lat:35.1188909996361,lng:-90.1093930004404},{lat:35.1166909999278,lng:-90.1005929997126},{lat:35.1182870003259,lng:-90.0906100004006},{lat:35.1216689997666,lng:-90.0834209996758},{lat:35.131591000189,lng:-90.0711920001511},{lat:35.1389400002529,lng:-90.0647680002307},{lat:35.1518389997326,lng:-90.0669580003669},{lat:35.1536439997781,lng:-90.0705259999793},{lat:35.1563719999572,lng:-90.0919989997475},{lat:35.169011999721,lng:-90.1041700004442},{lat:35.1752819999294,lng:-90.1087570004058},{lat:35.17886499998,lng:-90.1094860003269},{lat:35.1816910000093,lng:-90.1142139998555},{lat:35.1878900000935,lng:-90.1173930002038},{lat:35.1984980000222,lng:-90.1161820002339},{lat:35.199105000228,lng:-90.109076000248},{lat:35.1948480002065,lng:-90.0964660000585},{lat:35.2123759998207,lng:-90.0885969998164},{lat:35.2076880000456,lng:-90.0800849998671},{lat:35.2105889997374,lng:-90.0743920004158},{lat:35.2183159998541,lng:-90.0742619998211},{lat:35.2288380002134,lng:-90.0793450000753},{lat:35.249982999842,lng:-90.0979470003652},{lat:35.2542880002279,lng:-90.1050929996356},{lat:35.2557879997438,lng:-90.1164929996802},{lat:35.2522890001125,lng:-90.1403940001343},{lat:35.2559890000478,lng:-90.1520939997545},{lat:35.2625770001718,lng:-90.1588650000045},{lat:35.2802800001742,lng:-90.1689240003828},{lat:35.2845639999834,lng:-90.1690790001935},{lat:35.296114999734,lng:-90.1638119998163},{lat:35.3006370002211,lng:-90.1589129996851},{lat:35.3033019996851,lng:-90.1494490002319},{lat:35.2991139998684,lng:-90.1388640003221},{lat:35.3045299998037,lng:-90.123706999621},{lat:35.3034119997107,lng:-90.1161139995635},{lat:35.3049870003379,lng:-90.1090929999665},{lat:35.3246179997427,lng:-90.1068240001875},{lat:35.3324049997845,lng:-90.1038619995743},{lat:35.3427880000287,lng:-90.1102930000657},{lat:35.3431429999746,lng:-90.1073120000842},{lat:35.3572160001604,lng:-90.0968250000837},{lat:35.3632700000136,lng:-90.0879030000555},{lat:35.3841519998463,lng:-90.0749919995671},{lat:35.3852720001743,lng:-90.0799300000564},{lat:35.3952569997578,lng:-90.0966500001816},{lat:35.4014870003429,lng:-90.1048419995655},{lat:35.4101529999112,lng:-90.1125040001183},{lat:35.4137590002237,lng:-90.129492999857},{lat:35.4129769998085,lng:-90.1351250001072},{lat:35.4092250001599,lng:-90.140921000389},{lat:35.4055540002652,lng:-90.1441650001363},{lat:35.3994679999066,lng:-90.1461910002409},{lat:35.3876020001256,lng:-90.1434749996749},{lat:35.3766679997786,lng:-90.1355100000717},{lat:35.3746329997337,lng:-90.1449240001945},{lat:35.3747449997637,lng:-90.16624600035},{lat:35.3820919997073,lng:-90.1783409999804},{lat:35.385193999949,lng:-90.1792649998951},{lat:35.4105299996636,lng:-90.1706759999528},{lat:35.4187970002032,lng:-90.1705119999213},{lat:35.4222059996978,lng:-90.1688819996517},{lat:35.4419299999227,lng:-90.1294469998263},{lat:35.459112999973,lng:-90.1237560000248},{lat:35.4683280003639,lng:-90.1189280000388},{lat:35.4768360000455,lng:-90.1078369997907},{lat:35.4768309999472,lng:-90.1017719998955},{lat:35.4785540000427,lng:-90.0987340000125},{lat:35.4782970000804,lng:-90.0836500000047},{lat:35.472545999647,lng:-90.0741320001248},{lat:35.4667799997889,lng:-90.068155999918},{lat:35.4609519996426,lng:-90.0672289996302},{lat:35.4396109998964,lng:-90.0740629996295},{lat:35.4340430002881,lng:-90.0740459999111},{lat:35.4232910001488,lng:-90.0705490004438},{lat:35.4151799999946,lng:-90.0620180002278},{lat:35.4081630002331,lng:-90.0694339998351},{lat:35.3892770001504,lng:-90.0543220002381},{lat:35.3930730002377,lng:-90.044581999702},{lat:35.3966200002484,lng:-90.0415630000857},{lat:35.4038629998753,lng:-90.0567819998127},{lat:35.4129659996465,lng:-90.046597999761},{lat:35.4212369998146,lng:-90.0426400001613},{lat:35.4276619998141,lng:-90.0315840000733},{lat:35.4330539997828,lng:-90.0310209998336},{lat:35.4401030000938,lng:-90.0265839996598},{lat:35.4477879997185,lng:-90.0266039997513},{lat:35.4662309996885,lng:-90.0189160001575},{lat:35.4702910002407,lng:-90.0203329999917},{lat:35.4794109998313,lng:-90.0337900001031},{lat:35.4923390000974,lng:-90.0434619999688},{lat:35.510454000226,lng:-90.0498099997212},{lat:35.5210490000949,lng:-90.0495400002828},{lat:35.537467000233,lng:-90.0419609995706},{lat:35.5485569998391,lng:-90.0395500003998},{lat:35.5525119998285,lng:-90.0351180002488},{lat:35.556176000034,lng:-90.0261130003799},{lat:35.5560099998088,lng:-90.017582000164},{lat:35.5600910002819,lng:-90.007993000139},{lat:35.5611930002688,lng:-89.9992440003631},{lat:35.5601359998114,lng:-89.9894989998042},{lat:35.5553280002864,lng:-89.9789170002674},{lat:35.5419160002969,lng:-89.9588489997396},{lat:35.5337879997665,lng:-89.9556900003812},{lat:35.5271920001611,lng:-89.9577149997626},{lat:35.5200900002189,lng:-89.948010000285},{lat:35.5185379998524,lng:-89.9336140001903},{lat:35.5138700002248,lng:-89.9193310000735},{lat:35.5156919996687,lng:-89.9144839998208},{lat:35.5205479997059,lng:-89.9090220003483},{lat:35.5341750003641,lng:-89.9038820001927},{lat:35.5371940001641,lng:-89.9064580001182},{lat:35.5379509996993,lng:-89.9124019996397},{lat:35.5419599998556,lng:-89.9097400003987},{lat:35.5421210002444,lng:-89.9075789996765},{lat:35.5473779997255,lng:-89.9088709998372},{lat:35.5494319998331,lng:-89.9124789996326},{lat:35.551453999818,lng:-89.9286849999219},{lat:35.5568590001347,lng:-89.9418750000695},{lat:35.5766080001325,lng:-89.9544719998402},{lat:35.58536900003,lng:-89.9578770001443},{lat:35.5885300002917,lng:-89.9574949996546},{lat:35.59462399991,lng:-89.9536940004137},{lat:35.6007890000516,lng:-89.9467109995532},{lat:35.6121800000893,lng:-89.9195529998313},{lat:35.617555999828,lng:-89.9110819998898},{lat:35.6150250000394,lng:-89.8997520001655},{lat:35.6155350000581,lng:-89.8943450000462},{lat:35.6260040002644,lng:-89.8778629995724},{lat:35.6341519998545,lng:-89.8570650001969},{lat:35.6442610003553,lng:-89.8518239997589},{lat:35.6574239996727,lng:-89.8511579995871},{lat:35.6683120003279,lng:-89.8579420002559},{lat:35.6703880001562,lng:-89.8647390004453},{lat:35.6661360003596,lng:-89.8771579999408},{lat:35.6551069997997,lng:-89.8849319997483},{lat:35.6515139998436,lng:-89.894566999804},{lat:35.6509969998607,lng:-89.9042300003472},{lat:35.6527819997329,lng:-89.9154270000021},{lat:35.6600440000173,lng:-89.9310359997165},{lat:35.6657109999367,lng:-89.9373829996441},{lat:35.675120999858,lng:-89.94270000025},{lat:35.6906209996729,lng:-89.9557530001303},{lat:35.7238349999952,lng:-89.9588789998768},{lat:35.7333880003109,lng:-89.9562519998976},{lat:35.7384939997654,lng:-89.9502770004141},{lat:35.7530250000032,lng:-89.9191069997675},{lat:35.759387000298,lng:-89.9098249998892},{lat:35.7595620001419,lng:-89.9063619998588},{lat:35.7500770000229,lng:-89.8881629999751},{lat:35.7449840002374,lng:-89.8835350000055},{lat:35.7413689997149,lng:-89.87725599985},{lat:35.7380259999282,lng:-89.8764619996317},{lat:35.7465769998356,lng:-89.8656309996746},{lat:35.7554989998716,lng:-89.8471270001924},{lat:35.7549410002589,lng:-89.8368000000255},{lat:35.7568679999846,lng:-89.8208759997685},{lat:35.7611540001451,lng:-89.8128910000738},{lat:35.7715159996495,lng:-89.8048629998231},{lat:35.775438999979,lng:-89.7992490000145},{lat:35.7826479999668,lng:-89.7970530000306},{lat:35.7885030001334,lng:-89.7993310000303},{lat:35.7928069998658,lng:-89.7963240001095},{lat:35.8052959998136,lng:-89.7811759996292},{lat:35.809512999738,lng:-89.76545700031},{lat:35.8112129997233,lng:-89.7654380000434},{lat:35.8057809999703,lng:-89.7433190001948},{lat:35.8060469996775,lng:-89.734706999788},{lat:35.809246999983,lng:-89.7238330001732},{lat:35.8196070002743,lng:-89.7043870003346},{lat:35.8249149996771,lng:-89.7015229996306},{lat:35.8299120002226,lng:-89.7011910002679},{lat:35.8341529996855,lng:-89.7028829995634},{lat:35.8372020000929,lng:-89.7063520003399},{lat:35.847632000314,lng:-89.729517000302},{lat:35.8583129997283,lng:-89.7643430004244},{lat:35.8650979997542,lng:-89.7724670000363},{lat:35.8762440000246,lng:-89.7728550003739},{lat:35.8912989999551,lng:-89.7656890001136},{lat:35.9066529996905,lng:-89.7426060001673},{lat:35.9062470000979,lng:-89.7149339997112},{lat:35.896945000091,lng:-89.6881369996644},{lat:35.8843639998003,lng:-89.675084999609},{lat:35.882866000246,lng:-89.6661009996565},{lat:35.8937669996475,lng:-89.6483649995551},{lat:35.8914189997462,lng:-89.6453459999387},{lat:35.894781999771,lng:-89.6443950002598},{lat:35.899801999665,lng:-89.6465560000837},{lat:35.9043510002339,lng:-89.6448379999506},{lat:35.9226179998816,lng:-89.6531399998377},{lat:35.9477160002529,lng:-89.6869240000447},{lat:35.9630340002498,lng:-89.7145649996403},{lat:35.9709390000179,lng:-89.7196789998566},{lat:35.985975999916,lng:-89.7191680003938},{lat:35.9935680003498,lng:-89.7284419998762},{lat:36.0006079997882,lng:-89.7330949999601},{lat:36.0009810002107,lng:-89.7069320002981},{lat:36.0080399996589,lng:-89.7035710003749},{lat:36.0205069998186,lng:-89.6924369995709},{lat:36.0292379999638,lng:-89.6885769998805},{lat:36.0846360003597,lng:-89.6788210003492},{lat:36.0918369999119,lng:-89.6724629996527},{lat:36.0958020002264,lng:-89.666597999774},{lat:36.1068529997718,lng:-89.6283050003214},{lat:36.1205150002158,lng:-89.6005009996209},{lat:36.129699000072,lng:-89.5930699999451},{lat:36.1501199998752,lng:-89.5922060003048},{lat:36.1645580003422,lng:-89.6008710004151},{lat:36.1759750001802,lng:-89.6129829997639},{lat:36.1825779998312,lng:-89.6226770002692},{lat:36.1889510002935,lng:-89.6368940002638},{lat:36.2015300002649,lng:-89.6548760004125},{lat:36.2159110002374,lng:-89.6795479997221},{lat:36.230821000004,lng:-89.6996770003493},{lat:36.2365680000942,lng:-89.70525000015},{lat:36.2389830000286,lng:-89.7055249996113},{lat:36.25059100007,lng:-89.6985679995884},{lat:36.2527659998872,lng:-89.6952350001526},{lat:36.2482870001655,lng:-89.6780430000243},{lat:36.2506920001523,lng:-89.6525199996966},{lat:36.2494859998313,lng:-89.6421819996591},{lat:36.2392709997977,lng:-89.6111449999802},{lat:36.2381060002447,lng:-89.6023739995647},{lat:36.2394840000614,lng:-89.5873260004402},{lat:36.2422619998458,lng:-89.5775440000713},{lat:36.2509090000381,lng:-89.5622059996203},{lat:36.2503409996923,lng:-89.5535630001496},{lat:36.2474840002193,lng:-89.5447430002286},{lat:36.2488210002333,lng:-89.5392289999792},{lat:36.2525730000484,lng:-89.5347449999497},{lat:36.2618029998204,lng:-89.5345070002983},{lat:36.2728269999102,lng:-89.5364410003415},{lat:36.2773680003541,lng:-89.5394869997221},{lat:36.2804580003384,lng:-89.544796999757},{lat:36.2777530000388,lng:-89.5542960002686},{lat:36.288316999728,lng:-89.5784920002755},{lat:36.2968139997317,lng:-89.58982000035},{lat:36.3090880000642,lng:-89.6118189996497},{lat:36.3230060000856,lng:-89.6202550003294},{lat:36.3295460003538,lng:-89.6198000000447},{lat:36.3360850001595,lng:-89.6158409997218},{lat:36.3404419999384,lng:-89.6106889998706},{lat:36.3422340002686,lng:-89.605668000439},{lat:36.3423570002973,lng:-89.5816359995654},{lat:36.3377459998622,lng:-89.5604389999817},{lat:36.3368089997813,lng:-89.5450059999944},{lat:36.3392460001634,lng:-89.5318219996945},{lat:36.3485999999969,lng:-89.5189999997929},{lat:36.3598969998308,lng:-89.5131779995719},{lat:36.3736260001334,lng:-89.5097220001125},{lat:36.378355999696,lng:-89.5103799998884},{lat:36.4004459997604,lng:-89.5252930001921},{lat:36.4201030000283,lng:-89.5423370001824},{lat:36.427079000283,lng:-89.5452550004147},{lat:36.4349149997603,lng:-89.545061000246},{lat:36.4387700003507,lng:-89.543405999862},{lat:36.4539909999172,lng:-89.5251900002599},{lat:36.4670019999501,lng:-89.5197200003914},{lat:36.4786679999244,lng:-89.520641999758},{lat:36.4914319999867,lng:-89.5345240000168},{lat:36.4979339999487,lng:-89.5392320003523},{lat:36.4974909999145,lng:-89.4854270003714},{lat:36.4789590001873,lng:-89.493376999906},{lat:36.4705000002609,lng:-89.4930820003533},{lat:36.4621140002899,lng:-89.4861930001024},{lat:36.4575599997246,lng:-89.471894999917},{lat:36.4586859998257,lng:-89.460766999859},{lat:36.4648820003093,lng:-89.4489640003067},{lat:36.4821009998405,lng:-89.4300719995886},{lat:36.4990289997789,lng:-89.4182199996325},{lat:36.4992159998474,lng:-89.3910569998878},{lat:36.5072329999293,lng:-89.301022000369},{lat:36.5020760001394,lng:-88.9597459998297},{lat:36.502175999753,lng:-88.5418740003397},{lat:36.4998269997338,lng:-88.216645000081},{lat:36.497057999768,lng:-88.0532929997222},{lat:36.510784000243,lng:-88.039069000055},{lat:36.5228580000517,lng:-88.0374320001127},{lat:36.5278449996655,lng:-88.0346829999348},{lat:36.5369850001342,lng:-88.0326750002718},{lat:36.5420949996722,lng:-88.0326490003325},{lat:36.5601889999794,lng:-88.0350930000136},{lat:36.576823999771,lng:-88.0404969997599},{lat:36.6030699996432,lng:-88.0448619999637},{lat:36.6303400002476,lng:-88.0556250001487},{lat:36.6403429999449,lng:-88.0570160000436},{lat:36.6558559997368,lng:-88.0668360000473},{lat:36.6782550000303,lng:-88.070540999927},{lat:36.6771900003587,lng:-88.0122030004112},{lat:36.6689359998071,lng:-87.9268749996064},{lat:36.6636949998913,lng:-87.8495439999885},{lat:36.6331600000416,lng:-87.8533190001884},{lat:36.6404149997715,lng:-87.4746869996318},{lat:36.6427299996558,lng:-87.0704909996379},{lat:36.6524430002861,lng:-86.5899060003825},{lat:36.6335619996496,lng:-86.5639090004018},{lat:36.6379980002808,lng:-86.5512220002194},{lat:36.6447590003053,lng:-86.5499429995791},{lat:36.6438549998067,lng:-86.5433520001524},{lat:36.6404269997361,lng:-86.5438219996074},{lat:36.6523789998674,lng:-86.5077810002153},{lat:36.6522400003515,lng:-86.4934279997784},{lat:36.6487010002252,lng:-86.3321259998138},{lat:36.6418779999329,lng:-86.2361550002712},{lat:36.6302929997492,lng:-86.0248190003277},{lat:36.6221000001221,lng:-85.8324320001053},{lat:36.6220550003567,lng:-85.7888580000319},{lat:36.618222999676,lng:-85.676529999689},{lat:36.6148550002275,lng:-85.5015070000223},{lat:36.6245079997247,lng:-85.3247910003369},{lat:36.624448999707,lng:-85.300415000405},{lat:36.6263549998507,lng:-85.2939040004459},{lat:36.6252079996645,lng:-85.1862700001948},{lat:36.6192989999816,lng:-85.0268610002654},{lat:36.6045359998007,lng:-84.8300350002194},{lat:36.5963040000978,lng:-84.5404739999822},{lat:36.5962109997332,lng:-84.4488960002325},{lat:36.5917029999358,lng:-84.2715450003374},{lat:36.5898569996559,lng:-83.9999429997844},{lat:36.5825960002864,lng:-83.6907890002937},{lat:36.6008100002783,lng:-83.6750139999997},{lat:36.5979739999654,lng:-83.622000999689},{lat:36.5973849998572,lng:-83.5569220000604},{lat:36.5981870002347,lng:-83.2762999995698},{lat:36.5938869999873,lng:-83.2610990002844},{lat:36.5938269999794,lng:-83.2489329996106},{lat:36.5936440000278,lng:-82.6634909998711},{lat:36.5958209997755,lng:-82.487237999968},{lat:36.5944800000806,lng:-82.4665760001366},{lat:36.5960300003309,lng:-82.2226150000775},{lat:36.5946070000493,lng:-82.1737870000456},{lat:36.5942129999361,lng:-81.9341440003346},{lat:36.6162130002575,lng:-81.9226439998327},{lat:36.6119180002695,lng:-81.6468999995569},{lat:36.5858179996454,lng:-81.6800109999193},{lat:36.5811239999424,lng:-81.6769789998841},{lat:36.5786679997141,lng:-81.6792140002262},{lat:36.5707549999169,lng:-81.6770469996562},{lat:36.56867199995,lng:-81.6800720000187},{lat:36.5677160001577,lng:-81.6912860002903},{lat:36.5659409999698,lng:-81.6918779999441},{lat:36.5614409999225,lng:-81.6895480000657},{lat:36.5553900002694,lng:-81.6909980004103},{lat:36.5516860000305,lng:-81.6902209999103},{lat:36.5509990001271,lng:-81.6933609999005},{lat:36.5479770000695,lng:-81.6937900002459},{lat:36.5403159999463,lng:-81.6997680001025},{lat:36.5367270001968,lng:-81.6997949998667},{lat:36.5358299999513,lng:-81.7080209995858},{lat:36.5241139997382,lng:-81.7080979995787},{lat:36.5211410002483,lng:-81.702970000017},{lat:36.5097170000587,lng:-81.6983439996973},{lat:36.5064359998167,lng:-81.698398000124},{lat:36.5059199996449,lng:-81.6970909998946},{lat:36.5021549997366,lng:-81.6974239999805},{lat:36.4984570002495,lng:-81.7002540003493},{lat:36.4964239999371,lng:-81.6972449998804},{lat:36.4916190003452,lng:-81.69594900042},{lat:36.4889489999225,lng:-81.6979239995727},{lat:36.4755370003509,lng:-81.696350000278},{lat:36.473372000358,lng:-81.6946079998554},{lat:36.4697450002226,lng:-81.6961789996754},{lat:36.4674580001919,lng:-81.6950289998049},{lat:36.4640680000074,lng:-81.6990009996483},{lat:36.4622259996866,lng:-81.7081179996702},{lat:36.4593789997039,lng:-81.7096679995739},{lat:36.456669000139,lng:-81.7167970000242},{lat:36.44717299992,lng:-81.7137869997304},{lat:36.4450230001924,lng:-81.7178260004192},{lat:36.4414800001571,lng:-81.7144980001081},{lat:36.4372270001804,lng:-81.7148029997066},{lat:36.4339000003547,lng:-81.7213170000387},{lat:36.429856999665,lng:-81.7178470003356},{lat:36.4226510002782,lng:-81.7207270000348},{lat:36.4198690000698,lng:-81.7271519997802},{lat:36.4158949996947,lng:-81.7294409996506},{lat:36.4146839996491,lng:-81.7336500002188},{lat:36.4124970003087,lng:-81.734518000057},{lat:36.4135180000179,lng:-81.737659999697},{lat:36.4124219996805,lng:-81.7417050002337},{lat:36.4083019997255,lng:-81.7400220002607},{lat:36.4030639998354,lng:-81.7414059995846},{lat:36.4008340002437,lng:-81.7382699997924},{lat:36.3955910000337,lng:-81.7393679997844},{lat:36.3949290001743,lng:-81.731958000025},{lat:36.3915500001619,lng:-81.7288149996617},{lat:36.3882850001305,lng:-81.7305129997033},{lat:36.3854389997744,lng:-81.729497999552},{lat:36.3794420000313,lng:-81.7346600003472},{lat:36.368785000245,lng:-81.7260660003821},{lat:36.365586000115,lng:-81.7271159997952},{lat:36.3612369997277,lng:-81.7228829998358},{lat:36.3586400002506,lng:-81.7225199996127},{lat:36.357694999999,lng:-81.7243730003633},{lat:36.3513040003035,lng:-81.7215210002532},{lat:36.347595000241,lng:-81.716798999674},{lat:36.3463329998194,lng:-81.7082420004171},{lat:36.3437239997573,lng:-81.706111999657},{lat:36.3414149999425,lng:-81.7053230003598},{lat:36.3352249997168,lng:-81.7074749999629},{lat:36.3361219999975,lng:-81.7184940002409},{lat:36.3413829997549,lng:-81.7278380000435},{lat:36.3429719996975,lng:-81.7360289996026},{lat:36.3397569996892,lng:-81.7396060003341},{lat:36.3375920002677,lng:-81.7457330001536},{lat:36.3369990002825,lng:-81.7544700002339},{lat:36.3402539999174,lng:-81.7611319998057},{lat:36.3387219996576,lng:-81.7649539998613},{lat:36.3424630002662,lng:-81.7691700001022},{lat:36.3438240001882,lng:-81.774076999731},{lat:36.34856600004,lng:-81.7788889998236},{lat:36.3483279999264,lng:-81.7897299998263},{lat:36.355641999893,lng:-81.7907559998483},{lat:36.3589579997784,lng:-81.7935879998669},{lat:36.3624079996442,lng:-81.7930849999017},{lat:36.3585449996914,lng:-81.7972800002262},{lat:36.3579989997807,lng:-81.8009320004025},{lat:36.3518500001487,lng:-81.8102760002051},{lat:36.347331999645,lng:-81.8330489996316},{lat:36.3370119996448,lng:-81.8519110002125},{lat:36.337211000188,lng:-81.8549879995552},{lat:36.3291930002165,lng:-81.8655089998908},{lat:36.3262229999518,lng:-81.8666279997992},{lat:36.3137889997085,lng:-81.879520000021},{lat:36.3092380000287,lng:-81.8872360001022},{lat:36.3072519996457,lng:-81.8983459997185},{lat:36.3019659999487,lng:-81.9081670004454},{lat:36.2560330000674,lng:-81.9390080003057},{lat:36.2249489996805,lng:-81.9622159999254},{lat:36.1312079996502,lng:-82.0262009997601},{lat:36.1233930001085,lng:-82.0300670001966},{lat:36.1204750000205,lng:-82.0338390000235},{lat:36.1215670000662,lng:-82.0389239999275},{lat:36.1255560002165,lng:-82.0447550003693},{lat:36.1266239998432,lng:-82.0543169997319},{lat:36.1130619997449,lng:-82.0618689997815},{lat:36.1064329998392,lng:-82.0800280003806},{lat:36.1031699997524,lng:-82.0810789996186},{lat:36.1060020000051,lng:-82.0865319997686},{lat:36.105670999817,lng:-82.1003100002703},{lat:36.1078369999648,lng:-82.1054179997406},{lat:36.1043009998071,lng:-82.1163519996298},{lat:36.104559000284,lng:-82.1302249996677},{lat:36.1195099996561,lng:-82.1378560002584},{lat:36.1290390003512,lng:-82.136986999697},{lat:36.1387789999589,lng:-82.1410449997541},{lat:36.1404059996721,lng:-82.144451999708},{lat:36.1441380001213,lng:-82.1443680000424},{lat:36.1499029996916,lng:-82.1486889998653},{lat:36.1449719999714,lng:-82.1656500000149},{lat:36.14671399996,lng:-82.1685089997977},{lat:36.146500000037,lng:-82.172934000276},{lat:36.1423730002261,lng:-82.1772169995657},{lat:36.1439110001056,lng:-82.1836260003159},{lat:36.1509349999058,lng:-82.1874690002878},{lat:36.1491090001732,lng:-82.1929430003543},{lat:36.1572520001507,lng:-82.2041049998491},{lat:36.1590510001679,lng:-82.2136400003458},{lat:36.1569600001855,lng:-82.2220640004316}],
    /* eslint-enable */

    attach: function (context, settings) {
      if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) {
        document.createElement('template');
      }

      // Set main default route dropdown.
      Drupal.behaviors.componentRouteMap.updateMainRouteFilter();
      // Run through each route on the page.
      $('.component-biketennessee-routes-map:not(.component-route--initialized)').each(function () {
        // Add toggle.
        Drupal.behaviors.componentRouteMap.createToggle();

        // Get relevant script paths.
        var pathApiRoutes = '/api/1/routes?_format=json';

        // Retrieve relevant data for each route.
        $.when($(this), $.ajax(pathApiRoutes)).done(function (routeElement, routeAjaxData) {
          // If the ajax data was successfully returned, build the map.
          if (routeAjaxData[1] === 'success' && routeAjaxData[2].status === 200) {
            // Add # of results.
            var $resultsCategoryContainer = $('.component-route__form-summary-results-category-container', routeElement);
            var $resultsContainer = $('.component-route__form-summary', routeElement);
            Drupal.behaviors.componentRouteMap.routeCountTotal = routeAjaxData[0].count;
            $($resultsCategoryContainer).prepend('<p class="component-route__form-summary-total-results">' + Drupal.behaviors.componentRouteMap.routeCountTotal + ' Results</p>');
            $resultsContainer.addClass('js-active');

            // Build Each Route
            Drupal.behaviors.componentRouteMap.buildComponent(routeElement, routeAjaxData[0].results);

            // Store Route Data.
            drupalSettings.routeLocations = routeAjaxData[0].results;
          }
        });

        // Track that this route was initialized.
        $(this).addClass('component-route--initialized');
      });

      // Initialize each route callout on page load by calling window resize.
      $(window).resize();
    },

    /**
     * Build a route component based on route and route location data.
     *
     * @param {jQuery} $routeElement
     *   The Route jQuery element.
     * @param {array} routeLocations
     *   A list of locations on the current route.
     */
    buildComponent: function ($routeElement, routeLocations) {
      // Get the route ID.
      var routeId = $routeElement.data('route-id');

      // Track this component instance.
      var instanceId = Math.random().toString(36).substr(2, 9);
      $routeElement.attr('data-instance-id', instanceId);

      // Initialize the Map.
      var map = new google.maps.Map($routeElement.find('.component-route__map')[0], {
        center: {lat: 35.860119, lng: -86.660156},
        mapTypeControl: false,
        maxZoom: 19,
        styles: Drupal.behaviors.componentRouteMap.routeMapStyles,
        zoom: 8
      });

      // Construct a Polygon with a hole that covers the world
      // to darken everything around Tennessee's borders.
      // Define the LatLng coordinates for the polygon's outer path. (The Entire World).
      const outerCoords = Drupal.behaviors.componentRouteMap.worldBoundaries;

      // Define the LatLng coordinates for the polygon's inner path. (TN State Borders).
      // Note that the points forming the inner path are wound in the
      // opposite direction to those in the outer path, to form the hole.
      const innerCoords = Drupal.behaviors.componentRouteMap.stateBoundaries;

      // Construct the polygon, including both paths.
      const tennesseeStatePolygon = new google.maps.Polygon({
        paths: [outerCoords, innerCoords],
        strokeColor: Drupal.behaviors.componentRouteMap.colors.grey,
        strokeOpacity: 0.8,
        strokeWeight: 1,
        fillColor: Drupal.behaviors.componentRouteMap.colors.grey,
        fillOpacity: 0.15
      });

      tennesseeStatePolygon.setMap(map);

      // Track the map instance, route and location data for later use.
      Drupal.behaviors.componentRouteMap.routeLocations[routeId] = routeLocations;
      Drupal.behaviors.componentRouteMap.routeMaps[instanceId] = map;

      var infowindow = new google.maps.InfoWindow();
      var i = 0;
      var markers = [];
      var visualMarkers = [];
      var latLngArray = [];

      $routeElement.find('.component-route__route-list-item--placeholder').remove();

      // Add each location to the map and to the locations list.
      $.each(routeLocations, function (locationId, location) {
        // Skip location if the latitude or longitude are not set.
        if (location.geolocation.lat === null || location.geolocation.lng === null) {
          return true;
        }

        // Create location item and then add to location list.
        $routeElement.find('.component-route__route-list > ul').append(Drupal.behaviors.componentRouteMap.createLocationItem(location, i));

        // Set info window content.
        var infowWindowContent = '<p><strong>' + location.content.title + '</strong></br>';
        if (typeof location.contact !== 'undefined') {
          infowWindowContent += '</p>';
          if (typeof location.contact.page_link !== 'undefined' && location.contact.page_link !== null) {
            infowWindowContent += '<a href="' + location.contact.page_link + '">Learn More</a>';
          }
        }

        // Create visual Polyline for Route.
        var visualMarker = new google.maps.Polyline({
          path: location.geolocation.coordinates,
          strokeColor: Drupal.behaviors.componentRouteMap.colors.green,
          strokeOpacity: 1.0,
          strokeWeight: 3,
          title: location.content.title,
          id: locationId,
          markerListPosition: i
        });

        visualMarker.setMap(map);
        visualMarkers.push(visualMarker);

        // Create transparent Polyline for Route Interactivity
        var marker = new google.maps.Polyline({
          path: location.geolocation.coordinates,
          strokeColor: '#FF0000',
          strokeOpacity: 0.00001,
          strokeWeight: 15,
          title: location.content.title,
          id: locationId,
          markerListPosition: i
        });

        marker.setMap(map);
        markers.push(marker);

        // Add to latLngArray.
        latLngArray.push({
          lat: location.geolocation.lat,
          lng: location.geolocation.lng
        });

        // Add click event for marker to open location detail panel.
        marker.addListener('click', function () {
          Drupal.behaviors.componentRouteMap.showLocationDetail(instanceId, locationId, true);

          // if mobile, also show the Location Detail Panel.
          if ($('body').width() < 1024) {
            $('.map-toggle-bar__list-view').click();
          }
        });

        google.maps.event.addListener(marker, 'click', (function (marker) {
          return function () {
            infowindow.setContent(infowWindowContent);
            infowindow.open(map, marker);
          };
        })(marker));

        // Track marker for later.
        setNestedValue(Drupal.behaviors.componentRouteMap.routeMapMarkers, [instanceId, locationId], marker);
        setNestedValue(Drupal.behaviors.componentRouteMap.routeMapMarkersVisual, [instanceId, locationId], visualMarker);

        // Hover effect for route markers.
        google.maps.event.addListener(marker, 'mouseover', (function (marker) {
          return function () {
            visualMarker.setOptions({strokeColor: Drupal.behaviors.componentRouteMap.colors.grey});
          };
        })(marker));

        google.maps.event.addListener(marker, 'mouseout', (function (marker) {
          return function () {
            if (Number($('.route-location-detail').data('location-id')) !== Number(marker.id)) {
              visualMarker.setOptions({strokeColor: Drupal.behaviors.componentRouteMap.colors.green});
            }
            else if ($('.route-location-detail').length === 0) {
              visualMarker.setOptions({strokeColor: Drupal.behaviors.componentRouteMap.colors.green});
            }
          };
        })(marker));

        // This is setting the active (hover) color on routes when hovering over list item.
        $(once('trial-list-item-hover', '.component-route__route-list-item')).hover(function (event) {
          visualMarker.setOptions({strokeColor: Drupal.behaviors.componentRouteMap.colors.grey});
        },
        function () {
          // if ($('.route-location-detail').length === 0) {
          visualMarker.setOptions({strokeColor: Drupal.behaviors.componentRouteMap.colors.green});
          // }
        });

        i++;

      });

      Drupal.behaviors.componentRouteMap.routeLocationsLatLng = latLngArray;

      // Reorder location Items based on distance to map center.
      Drupal.behaviors.componentRouteMap.reorderLocationItems(instanceId);

      // Add click event for location list item to open location detail panel.
      $routeElement.on('click', 'li.component-route__route-list-item', function () {
        var asset = $(this).find('.route-location-item__title').text();
        dataLayer.push({
          eventCategory: 'bike tn- home',
          eventAction: 'read more',
          eventLabel: asset,
          eventvalue: '',
          event: 'eventClick'
        });
        Drupal.behaviors.componentRouteMap.showLocationDetail(instanceId, $(this).data('location-id'));
        return false;
      });

      $routeElement.on('focus', 'li.component-route__route-list-item', function () {
        if ($('body').hasClass('jsa-keyboard-activated')) {
          $(this).addClass('focused');
        }
      }).on('blur', 'li.component-route__route-list-item', function () {
        if ($('body').hasClass('jsa-keyboard-activated')) {
          $(this).removeClass('focused');
        }
      });

      // Add click event for location detail panel button to hide itself.
      $routeElement.on('click', 'button.route-location-detail__back-button', function () {
        Drupal.behaviors.componentRouteMap.hideLocationDetail(instanceId, $(this).closest('.route-location-detail').data('location-id'));
        return false;
      });

      google.maps.event.addListener(map, 'click', function (event) {
        infowindow.close();
      });

      $(document).mouseup(function (event) {
        var container = $('.component-route__map');
        if (!container.is(event.target) && container.has(event.target).length === 0) {
          infowindow.close();
        }
      });

      // Initialize timeout timer (to help center_changed from repeated fire).
      Drupal.behaviors.componentRouteMap.routeMapTimeout[instanceId] = null;

      // Track when map center has changed.
      map.addListener('center_changed', function () {
        clearTimeout(Drupal.behaviors.componentRouteMap.routeMapTimeout[instanceId]);
        Drupal.behaviors.componentRouteMap.routeMapTimeout[instanceId] = setTimeout(function () {
          Drupal.behaviors.componentRouteMap.reorderLocationItems(instanceId);
        }, 300);
      });

      // Track when user has dragged the map.
      google.maps.event.addListener(map, 'dragend', function () {
        // Clean previous map settings if user purposely drags the map.
        setNestedValue(Drupal.behaviors.componentRouteMap.routeMapSettings, [instanceId, 'center'], null);
        setNestedValue(Drupal.behaviors.componentRouteMap.routeMapSettings, [instanceId, 'scroll'], 0);
      });

      // Track that this route was processed.
      $routeElement.addClass('component-route--processed');
      $routeElement.find('.initializing').addClass('visually-hidden').html('Experience loaded.');

      // Handle Route Selection Filter.
      $('.form-item-route', $routeElement).pSelect({
        default: null,
        onChange: function (option) {
          Drupal.behaviors.componentRouteMap.showLocationDetail(instanceId, option.data('filterValue'));

          // Track analytics
          Drupal.behaviors.componentRouteMap.selectFiltersAnalytics('route selector', option.text());
        },
        onClear: function () {
          var instanceId = $('.component-route').attr('data-instance-id');
          var $routeElement = Drupal.behaviors.componentRouteMap.getRouteElement(instanceId);
          var $locationDetail = $routeElement.find('.route-location-detail');

          // If detail page is open, close it on filter interaction.
          if ($locationDetail.length > 0) {
            Drupal.behaviors.componentRouteMap.hideLocationDetail(instanceId, $locationDetail.data('location-id'));
          }

          // Track analytics
          Drupal.behaviors.componentRouteMap.clearFiltersAnalytics('route');
        }
      });

      var $routeFormSummary = $('.component-route__form-summary', $routeElement);
      var $routeFormSummaryCategoryListElement = $('.component-route__form-summary-category-list', $routeElement);

      // Track if we should filter by category.
      $('.form-item-filter', $routeElement).pOptions({
        default: null,
        onChange: function (option) {
          var $optionRouteElement = $(option).parents('.component-route');
          var filterData = $('.form-item-filter', $optionRouteElement).data();
          var filterCategories = getNestedValue(filterData, ['pOptions', 'value', 'category'], []);
          var $locationDetail = $optionRouteElement.find('.route-location-detail');
          var chosenTerrain = '';

          // If detail page is open, close it on filter interaction.
          if ($locationDetail.length > 0) {
            Drupal.behaviors.componentRouteMap.hideLocationDetail(instanceId, $locationDetail.data('location-id'));
          }

          // Filter categories by if they exist and then sort by title.
          filterCategories = filterCategories.filter(function (id) {
            return (drupalSettings.tnv_routes.content_categories.hasOwnProperty(id));
          }).sort(function (a, b) {
            if (drupalSettings.tnv_routes.content_categories[a].title < drupalSettings.tnv_routes.content_categories[b].title) {
              return -1;
            }
            if (drupalSettings.tnv_routes.content_categories[a].title > drupalSettings.tnv_routes.content_categories[b].title) {
              return 1;
            }
            return 0;
          });

          if (filterCategories !== []) {
            $routeFormSummary.addClass('js-active');
          }
          else {
            $routeFormSummary.removeClass('js-active');
          }

          // Wipe previous elements to re-add them.
          $routeFormSummaryCategoryListElement.find('li').remove();

          // Add categories to list.
          // eslint-disable-next-line guard-for-in
          for (var filterCategoriesKey in filterCategories) {
            if (filterCategories.hasOwnProperty(filterCategoriesKey)) {
              var filterCategory = drupalSettings.tnv_routes.content_categories[filterCategories[filterCategoriesKey]];
              chosenTerrain = filterCategory;
              var locationTypeListItem = document.createElement('li');
              locationTypeListItem.innerHTML = filterCategory.title;
              locationTypeListItem.setAttribute('data-location-type-id', filterCategory.id);
              $routeFormSummaryCategoryListElement.append(locationTypeListItem);
            }
          }

          // Track analytics
          // eslint-disable-next-line no-undefined
          if (chosenTerrain.title !== undefined) {
            Drupal.behaviors.componentRouteMap.selectFiltersAnalytics('terrain selector', chosenTerrain.title);
          }
          else {
            // Terrain types can also be un-filtered individually
            // Fire the "clear filter" event if all have been removed
            Drupal.behaviors.componentRouteMap.clearFiltersAnalytics('terrain');
          }
        },
        onClear: function () {
          // var filterInstanceId = $routeElement.attr('data-instance-id');
          var $locationDetail = $routeElement.find('.route-location-detail');

          // If detail page is open, close it on filter interaction.
          if ($locationDetail.length > 0) {
            Drupal.behaviors.componentRouteMap.hideLocationDetail(instanceId, $locationDetail.data('location-id'));
          }

          // Filter Map Locations (Not Needed until more Terrain Types are added).
          $routeFormSummaryCategoryListElement.find('li').remove();

          // Track analytics
          Drupal.behaviors.componentRouteMap.clearFiltersAnalytics('terrain');
        }
      });

      // Add the TMP filter button because we don't want to hard code it in the template
      $('.form-item-filter', $routeElement).find('.poptions__options').append('<a href="#" class="button tmp-filter-close-button" tabindex="-1">View Selections</a>');

      $('.tmp-filter-close-button').on('click', function (e) {
        var filterPlugin = $('.form-item-filter', $routeElement).data('pOptions');
        filterPlugin.toggle(false);
        e.preventDefault();
      });

      // Add click event for category pills to disable themselves.
      $routeFormSummaryCategoryListElement.on('click', 'li', function () {
        var filterPlugin = $('.form-item-filter', $routeElement).data('pOptions');
        var filterPluginOption = filterPlugin.getOption('category', $(this).data('location-type-id'));
        var selectedCategory = $(this).data('location-type-id');
        filterPlugin.unselect(filterPluginOption);
        $('.modal[data-filter-name="location-type"]', $routeElement).find('input[type=checkbox][value=' + selectedCategory + ']').prop('checked', false);
      });

      // Add click event for category clear to remove the category pills.
      $('.component-route__form-summary-category-clear', $routeElement).on('click', function () {
        var filterPlugin = $('.form-item-filter', $routeElement).data('pOptions');
        filterPlugin.clear();
        $('.modal[data-filter-name="location-type"]', $routeElement).find('input[type=checkbox]').each(function () {
          $(this).prop('checked', false);
        });

        var filterCity = $('.form-item-going', $routeElement).data('pOptions');
        filterCity.clear();
      });

      $('.poptions__clear.tmp-filters.active', $routeElement).on('click', function () {
        $('.modal[data-filter-name="location-type"]', $routeElement).find('input[type=checkbox]').each(function () {
          $(this).prop('checked', false);
        });
      });

      // Track if we should filter by location.
      var defaultLocation = null;

      $('.form-item-going', $routeElement).pSelect({
        default: defaultLocation,
        onChange: function (option) {
          var $locationDetail = $routeElement.find('.route-location-detail');
          var filterCity = $routeElement.find('.form-item-going').data('pSelect').getValue();

          // If detail page is open, close it on filter interaction.
          if ($locationDetail.length > 0) {
            Drupal.behaviors.componentRouteMap.hideLocationDetail(instanceId, $locationDetail.data('location-id'));
          }

          // Zoom in map to selected City
          Drupal.behaviors.componentRouteMap.filterMapGeolocation($routeElement.attr('data-instance-id'));

          // Filter Map Locations.
          Drupal.behaviors.componentRouteMap.filterMapLocations(instanceId, [], filterCity.data('filterValue'));

          // Track analytics
          Drupal.behaviors.componentRouteMap.selectFiltersAnalytics('city selector', filterCity.text());
        },
        onClear: function (plugin) {
          var $filterRouteElement = $(plugin.element).parents('.component-route');
          var $locationDetail = $routeElement.find('.route-location-detail');

          // If detail page is open, close it on filter interaction.
          if ($locationDetail.length > 0) {
            Drupal.behaviors.componentRouteMap.hideLocationDetail(instanceId, $locationDetail.data('location-id'));
          }

          // Reset Map Position
          Drupal.behaviors.componentRouteMap.filterMapGeolocation($filterRouteElement.attr('data-instance-id'));

          // Reset Map Locations List.
          Drupal.behaviors.componentRouteMap.filterMapLocations(instanceId, []);

          // Reset Results Count.
          $('.component-route__form-summary-total-results').html(Drupal.behaviors.componentRouteMap.routeCountTotal + ' Results');

          // Track analytics
          Drupal.behaviors.componentRouteMap.clearFiltersAnalytics('city');
        }
      });

      // Resize map to make sure all of Tennessee is in-bounds.
      Drupal.behaviors.componentRouteMap.positionMap(instanceId, null, null, latLngArray);

      // Init mobile filtering
      Drupal.behaviors.componentRouteMap.initializeMobileFilters($routeElement);
      Drupal.behaviors.componentRouteMap.mobileFilterClickEvents($routeElement);
      $(window).resize(function () {
        Drupal.behaviors.componentRouteMap.initializeMobileFilters($routeElement);
      });
    },

    /**
     * Build a map toggle for mobile users.
     *
     */
    createToggle: function () {
      var toggle = $('.map-toggle');
      var map = $('.component-route__map-wrapper');

      // Make the List View tab red on load.
      $('.map-toggle-bar__list-view').addClass('active-tab');

      toggle.on('click', function (e) {
        $('body').toggleClass('route-map-active');
        $(map).toggleClass('map-active');
        if ($(map).hasClass('map-active')) {
          $('.map-toggle-bar__map-view').addClass('active-tab');
          $('.map-toggle-bar__list-view').removeClass('active-tab');
        }
        if (!$(map).hasClass('map-active')) {
          $('.map-toggle-bar__list-view').addClass('active-tab');
          $('.map-toggle-bar__map-view').removeClass('active-tab');
        }
      });
    },

    /**
     * Create's a route location's list item for the route location list.
     *
     * @param {object} location
     *   The route location object.
     * @param {string} markerPosition
     *   The index of the locations marker in the google maps marker array.
     * @return {Node}
     *   A li document fragment.
     */
    createLocationItem: function (location, markerPosition) {
      // Create location item from template and update with location content.
      var locationItem = document.getElementById('component-route__route-location').content.cloneNode(true);
      locationItem.querySelector('li').setAttribute('data-location-id', location.id);
      locationItem.querySelector('li').setAttribute('data-marker-id', markerPosition);
      locationItem.querySelector('li').setAttribute('data-hub-city', location.tagging.city.id);
      locationItem.querySelector('.route-location-detail__title-city').innerHTML = location.tagging.type[Object.keys(location.tagging.type)[0]]['id'];
      locationItem.querySelector('.route-location-item__title').innerHTML = location.content.title;
      if (location.content.img_detail_small !== null && location.content.img_detail_small.length > 0) {
        locationItem.querySelector('.route-location-item__image').innerHTML = location.content.img_detail_small;
      }
      else {
        locationItem.querySelector('.route-location-item__image').style.display = 'none';
      }

      // THIS MIGHT BE NEEDED FOR CATEGORIES
      $.each(location.tagging.type, function (locationTypeId) {
        if (locationTypeId in drupalSettings.tnv_routes.content_categories) {
          locationItem.querySelector('.route-location-item__meta-tags').insertAdjacentHTML('beforeend', '<li data-location-type-id="' + locationTypeId + '">' + drupalSettings.tnv_routes.content_categories[locationTypeId].title + '</li>');
        }
      });

      return locationItem;
    },

    /**
     * Reorders a list of route locations on a route component.
     *
     * @param {string} instanceId
     *   The route jQuery object.
     */
    reorderLocationItems: function (instanceId) {
      // Get route element and ID.
      var $routeElement = Drupal.behaviors.componentRouteMap.getRouteElement(instanceId);
      var routeId = $routeElement.data('route-id');

      // Determine map center.
      var mapCenter = Drupal.behaviors.componentRouteMap.getRouteMap(instanceId).getCenter();

      // Calculate each locations distance from the center of the map.
      $routeElement.find('.component-route__route-list-item').each(function () {
        var locationId = $(this).data('location-id');
        var location = Drupal.behaviors.componentRouteMap.getRouteLocation(routeId, locationId);
        this.dataset.distance = calculateDistance(mapCenter.lat(), mapCenter.lng(), location.geolocation.lat, location.geolocation.lng);
      });

      // Sort the location items.
      var listItems = $routeElement.find('.component-route__route-list-item').get();
      listItems.sort(function (a, b) {
        if (parseFloat(a.dataset.distance) < parseFloat(b.dataset.distance)) {
          return -1;
        }
        else if (parseFloat(a.dataset.distance) > parseFloat(b.dataset.distance)) {
          return 1;
        }
        return 0;
      });

      // Reorder the location list items.
      var $listContainer = $routeElement.find('.component-route__route-list > ul');
      $.each(listItems, function (index, item) {
        $listContainer.append(item);
      });

      // Figure out if the list should be reset to a previous position.
      var mapLocationScroll = getNestedValue(Drupal.behaviors.componentRouteMap.routeMapSettings, [instanceId, 'scroll'], 0);
      // If a detail isn't being shown, reset scroll.
      if (typeof $routeElement.data('detail-location-id') === 'undefined') {
        setNestedValue(Drupal.behaviors.componentRouteMap.routeMapSettings, [instanceId, 'scroll'], 0);
      }

      // Scroll to the list to either the previous position or top.
      $routeElement.find('.component-route__route-list').scrollTop(mapLocationScroll);

      if ($('body').hasClass('jsa-keyboard-activated')) {
        $.each(listItems, function (index, item) {
          if ($(this).hasClass('focused')) {
            $(this).find('button.route-location-item__read-more-button').focus();
          }
        });
      }
    },

    /**
     * Builds a route location's detail element.
     *
     * @param {string} instanceId
     *   The Route instance ID.
     * @param {number} locationId
     *   The Route location ID.
     *
     * @return {Node}
     *   The route location's detail element.
     */
    buildLocationDetailElement: function (instanceId, locationId) {
      // Load route and location information.
      var $routeElement = Drupal.behaviors.componentRouteMap.getRouteElement(instanceId);
      var routeId = $routeElement.data('route-id');
      var location = Drupal.behaviors.componentRouteMap.getRouteLocation(routeId, locationId);

      // Create new detail element from template.
      var detailElement = document.getElementById('component-route__route-location-detail').content.cloneNode(true);

      // Set header title and city.
      detailElement.querySelector('.route-location-detail__title-label').innerHTML = location.content.title;
      if (!$.isEmptyObject(location.tagging.city)) {
        detailElement.querySelector('.route-location-detail__title-city').innerHTML = location.tagging.city.title;
      }

      // Get image from location content.
      var image_output = null;
      var image_path_is_custom = false;
      if (location.content.img_detail_large !== null && location.content.img_detail_large.length > 0) {
        image_output = location.content.img_detail_large;
        image_path_is_custom = true;
      }

      // Set image if we an image path was found.
      if (image_output !== null) {
        detailElement.querySelector('.route-location-detail__title').innerHTML = image_output;
        if (image_path_is_custom) {
          detailElement.querySelector('.route-location-detail__title').classList.add('route-location-detail__title--with-image');
        }
      }
      else {
        // If no image path, then remove the background image and shorten height.
        $(detailElement.querySelector('.route-location-detail__title')).css({
          'background-image': 'none',
          'height': '2vw',
          'min-height': 'unset'
        });
        detailElement.querySelector('.route-location-detail').classList.add('no-image');
      }

      // Add mytrip id.
      var mtbutton = detailElement.querySelectorAll('.mytrip');
      for (var i = 0; i < mtbutton.length; i++) {
        mtbutton[i].setAttribute('data-entity-id', locationId);
        mtbutton[i].setAttribute('aria-label', 'Add or remove ' + location.content.title + ' from My Trip');
      }

      // Add content.
      detailElement.querySelector('.route-location-detail__info-distance').innerHTML = location.content.length + ' miles';
      detailElement.querySelector('.route-location-detail__info-elevation').innerHTML = location.content.elevation + ' feet of climbing';

      // Add content.
      detailElement.querySelector('.route-location-detail__content-description').innerHTML = location.content.description;

      // Update more-info link.
      if (location.contact.page_link !== null) {
        var learnMoreButton = detailElement.querySelector('.route-location-detail__content-buttons-button--more-info');
        var buttonText = Drupal.t('View Route');
        learnMoreButton.href = location.contact.page_link;
        learnMoreButton.setAttribute('aria-label', buttonText);
      }
      else {
        detailElement.querySelector('.route-location-detail__content-buttons-button--more-info').parentNode.removeChild(detailElement.querySelector('.route-location-detail__content-buttons-button--more-info'));
      }

      // Add marker position identifier
      var marker = Drupal.behaviors.componentRouteMap.getRouteMarker(instanceId, locationId);
      detailElement.querySelector('.route-location-detail').setAttribute('data-marker-id', marker.markerListPosition);
      detailElement.querySelector('.route-location-detail').setAttribute('data-location-id', locationId);

      return detailElement;
    },

    /**
     * Show a location detail panel based on route and location ID.
     *
     * @param {string} instanceId
     *   The Route instance ID.
     * @param {number} locationId
     *   The Route location ID.
     * @param {boolean} mapClicked
     *   Invoked by map click ?
     */
    showLocationDetail: function (instanceId, locationId, mapClicked = false) {
      if (activeIcon) {
        var activeMarker = Drupal.behaviors.componentRouteMap.getRouteMarkerVisual(instanceId, activeIcon);
        activeMarker.setOptions({strokeColor: Drupal.behaviors.componentRouteMap.colors.green});
      }
      var map = Drupal.behaviors.componentRouteMap.getRouteMap(instanceId);
      var visualMarker = Drupal.behaviors.componentRouteMap.getRouteMarkerVisual(instanceId, locationId);
      visualMarker.setOptions({strokeColor: Drupal.behaviors.componentRouteMap.colors.grey});
      activeIcon = locationId;

      var $routeElement = Drupal.behaviors.componentRouteMap.getRouteElement(instanceId);
      var $routeDetailContainerElement = $routeElement.find('.component-route__detail');

      var routeId = $routeElement.data('route-id');
      var location = Drupal.behaviors.componentRouteMap.getRouteLocation(routeId, locationId);
      // track click on map route
      var asset = location.content.title;
      if (mapClicked) {
        dataLayer.push({
          eventCategory: 'bike tn- home',
          eventAction: 'map selection',
          eventLabel: asset,
          eventvalue: '',
          event: 'eventClick'
        });
      }

      // Don't rebuild detail element if it's already selected.
      if ($routeElement.data('detail-location-id') === locationId) {
        return;
      }

      // Track map settings if location detail is currently not already shown.
      if (typeof $routeElement.data('detail-location-id') === 'undefined') {
        setNestedValue(Drupal.behaviors.componentRouteMap.routeMapSettings, [instanceId, 'center'], map.getCenter());
        setNestedValue(Drupal.behaviors.componentRouteMap.routeMapSettings, [instanceId, 'scroll'], $routeElement.find('.component-route__route-list').scrollTop());
        setNestedValue(Drupal.behaviors.componentRouteMap.routeMapSettings, [instanceId, 'zoom'], map.getZoom());
      }

      // Create detail item from template and update with location content.
      var detailElement = Drupal.behaviors.componentRouteMap.buildLocationDetailElement(instanceId, locationId);

      // Wipe detail container, add new element, track location ID & visibility.
      $routeDetailContainerElement.html('');
      $routeDetailContainerElement.append(detailElement);
      $routeElement.data('detail-location-id', locationId);
      $routeElement.addClass('component-route--location-detail-visible');

      if ($('body').hasClass('jsa-keyboard-activated')) {
        var $backButton = $routeElement.find('.route-location-detail__back-button');
        $backButton.focus();
      }

      // Zoom in to Route on map;
      var latPadding = 0.05;
      var lngPadding = 0.05;

      // Increase values to give some padding around bounds.
      var latMax = location.geolocation.latMax + latPadding;
      var latMin = location.geolocation.latMin - latPadding;
      var lngMax = location.geolocation.lngMax + lngPadding;
      var lngMin = location.geolocation.lngMin - lngPadding;

      // Create bounds object.
      var bounds = new google.maps.LatLngBounds();

      // Add NW latlng bounds.
      bounds.extend(new google.maps.LatLng(latMax, lngMin));
      // Add SE latlng bounds.
      bounds.extend(new google.maps.LatLng(latMin, lngMax));
      // Set bounds on map.
      map.fitBounds(bounds);

      // Trigger route list by calling window resize.
      $(window).resize();

      // Routes Map - View Route Button
      $(once('analytics', '.landing-page--bike-tn--consumer .route-location-detail__content-buttons-button')).click(function (e) {
        var asset = $(this).attr('href');
        dataLayer.push({
          eventCategory: 'bike tn- home',
          eventAction: 'view route',
          eventLabel: asset,
          eventvalue: '',
          event: 'eventClick'
        });
      });
    },

    /**
     * Send a 'clear filter' event to the dataLayer for Google Analytics.
     *
     * @param {string} label
     *   The filter label.
     */
    clearFiltersAnalytics: function (label) {
      dataLayer.push({
        eventCategory: 'bike tn- home',
        eventAction: 'clear filter',
        eventLabel: label,
        eventvalue: '',
        event: 'eventClick'
      });
    },

    /**
     * Send a 'select filter' event to the dataLayer for Google Analytics.
     *
     * @param {string} action
     *   The filter action.
     * @param {string} label
     *   The filter label.
     */
    selectFiltersAnalytics: function (action, label) {
      dataLayer.push({
        eventCategory: 'bike tn- home',
        eventAction: action,
        eventLabel: label,
        eventvalue: '',
        event: 'eventClick'
      });
    },

    /**
     * Hide the location detail panel of a route instance.
     *
     * @param {string} instanceId
     *   The Route instance ID.
     * @param {number} locationId
     *   The Route location ID.
     */
    hideLocationDetail: function (instanceId, locationId) {
      var map = Drupal.behaviors.componentRouteMap.getRouteMap(instanceId);
      var visualMarker = Drupal.behaviors.componentRouteMap.getRouteMarkerVisual(instanceId, locationId);
      var $routeElement = Drupal.behaviors.componentRouteMap.getRouteElement(instanceId);
      var $routeDetailContainerElement = $routeElement.find('.component-route__detail');

      // Hide old element.
      $routeElement.removeClass('component-route--location-detail-visible');
      $routeElement.removeData('detail-location-id');

      // Clear filter
      var autocompleFilter = $('input[data-drupal-selector=edit-attraction-search]').val();

      if (typeof autocompleFilter !== 'undefined') {
        $('input[data-drupal-selector=edit-attraction-search]').val('');
      }

      $('.js-form-item-attraction-search .pselect-clear').removeClass('active');

      // Allow element to hide before removing element.
      setTimeout(function () {
        $routeDetailContainerElement.html('');
      }, 500);

      // Get map center and zoom level from previous map settings. Center
      // defaults to current map center and zoom defaults to 15.
      var mapCenter = getNestedValue(Drupal.behaviors.componentRouteMap.routeMapSettings, [instanceId, 'center'], map.getCenter());
      var mapZoom = getNestedValue(Drupal.behaviors.componentRouteMap.routeMapSettings, [instanceId, 'zoom'], 15);

      // Clean previous map settings.
      setNestedValue(Drupal.behaviors.componentRouteMap.routeMapSettings, [instanceId, 'center'], null);
      setNestedValue(Drupal.behaviors.componentRouteMap.routeMapSettings, [instanceId, 'zoom'], null);

      // Make sure map zoom isn't too zoomed-in (marker clusters can act weird).
      if (mapZoom > 15) {
        mapZoom = 15;
      }

      // Reset map to previous settings
      map.setCenter(mapCenter);
      map.setZoom(mapZoom);

      if ($('body').hasClass('jsa-keyboard-activated')) {
        $('li.component-route__route-list-item[data-location-id="' + locationId + '"]').addClass('focused');
      }

      if (visualMarker) {
        visualMarker.setOptions({strokeColor: Drupal.behaviors.componentRouteMap.colors.green});
      }
    },

    /**
     * Get's a geolocation object with lat lng properties set.
     *
     * @param {jQuery} $option
     *   The option jQuery element.
     *
     * @return {null|Object}
     *   The geolocation object. Null otherwise
     */
    getFilterOptionGeolocation: function ($option) {
      if ($option !== null) {
        // Find all the routes that have the filtered city as their hub city.
        var filteredLocations = $(`.component-route__route-list-item[data-hub-city="${$option.data('filterValue')}"]`);
        var instanceId = $('.component-route').attr('data-instance-id');
        var $routeElement = Drupal.behaviors.componentRouteMap.getRouteElement(instanceId);
        var routeId = $routeElement.data('route-id');
        var minMaxCoordinates = {
          latMax: null,
          latMin: null,
          lngMax: null,
          lngMin: null
        };

        // Determine the min/max lat/lng from the whole group
        filteredLocations.each(function (index) {
          var location = Drupal.behaviors.componentRouteMap.getRouteLocation(routeId, $(filteredLocations[index]).data('location-id'));
          if (location.geolocation.latMin < minMaxCoordinates.latMin || minMaxCoordinates.latMin === null) {
            minMaxCoordinates.latMin = location.geolocation.latMin;
          }
          if (location.geolocation.latMax > minMaxCoordinates.latMax || minMaxCoordinates.latMax === null) {
            minMaxCoordinates.latMax = location.geolocation.latMax;
          }
          if (location.geolocation.lngMin < minMaxCoordinates.lngMin || minMaxCoordinates.lngMin === null) {
            minMaxCoordinates.lngMin = location.geolocation.lngMin;
          }
          if (location.geolocation.lngMax > minMaxCoordinates.lngMax || minMaxCoordinates.lngMax === null) {
            minMaxCoordinates.lngMax = location.geolocation.lngMax;
          }
        });

        return minMaxCoordinates;
      }

      return null;
    },

    /**
     * Reset map bounds based on current filter values.
     *
     * @param {string} instanceId
     *   The Route instance ID.
     */
    filterMapGeolocation: function (instanceId) {
      var $routeElement = Drupal.behaviors.componentRouteMap.getRouteElement(instanceId);
      var optionGoing = $routeElement.find('.form-item-going').data('pSelect').getValue();
      var filterGeolocationGoing = null;

      if (optionGoing !== null) {
        // Get bounds of all routes with this city as their hub city.
        filterGeolocationGoing = Drupal.behaviors.componentRouteMap.getFilterOptionGeolocation(optionGoing);
        Drupal.behaviors.componentRouteMap.positionMap(instanceId, filterGeolocationGoing, null, null);
      }

      // Reset Map Location after clearing city filter.
      else {
        Drupal.behaviors.componentRouteMap.positionMap(instanceId, null, null, null);
      }
    },


    /**
     * Filter the markers on the map based on passed in category IDs.
     *
     * @param {string} instanceId
     *   The Route instance ID.
     * @param {array} categories
     *   The array of category IDs to filter the markers by.
     * @param {number} cityId
     *   The Filtered City ID.
     */
    filterMapLocations: function (instanceId, categories, cityId = null) {
      var routeId = Drupal.behaviors.componentRouteMap.getRouteId(instanceId);
      var $routeElement = Drupal.behaviors.componentRouteMap.getRouteElement(instanceId);
      var totalFilteredStops = 0;

      $.each(Drupal.behaviors.componentRouteMap.getRouteLocations(routeId), function (locationId, location) {
        var marker = Drupal.behaviors.componentRouteMap.getRouteMarker(instanceId, locationId);
        var visualMarker = Drupal.behaviors.componentRouteMap.getRouteMarkerVisual(instanceId, locationId);
        var $routeListItem = $routeElement.find('.component-route__route-list-item[data-location-id="' + locationId + '"]');

        // Skip item if marker isn't defined.
        if (typeof marker === 'undefined') {
          return true;
        }

        // Default to attaching location.
        var attach = true;
        var filtered = [];

        // Check if any categories were passed in to filter by.
        if (categories.length > 0) {
          // Find if location matches any of the requested categories.
          filtered = Object.keys(location.tagging.type).filter(function (item) {
            return (categories.indexOf(item) !== -1);
          });

          // Attach if any match.
          attach = (filtered.length > 0);
        }

        if (cityId !== null) {
          // Find if location's hub city matches the requested filter.
          attach = (Number(location.tagging.city.id) === cityId) ? true : false;
        }

        // If categories are empty or if ID exists.
        if (attach) {
          marker.setVisible(true);
          visualMarker.setVisible(true);
          $routeListItem.removeClass('component-route__route-list-item--hide');
          totalFilteredStops++;
        }
        else {
          marker.setVisible(false);
          visualMarker.setVisible(false);
          $routeListItem.addClass('component-route__route-list-item--hide');
        }
      });

      // routeMarkerCluster.repaint();

      var $resultsContainer = $('.component-route__form-summary', $routeElement);
      var $resultsCount = $('.component-route__form-summary-total-results', $routeElement);
      var $asideTotalStops = $('.component-route__route-aside-total-stops', $routeElement);
      // var $resultsCategoryContainer = $('.component-route__form-summary-results-category-container', $routeElement);

      $('.filtered-stop-results', $asideTotalStops).remove();

      if (totalFilteredStops === 1 && (categories.length > 0 || cityId !== null)) {
        $($resultsCount).html(totalFilteredStops + ' Result');
        // $($resultsCategoryContainer).prepend('<p class="component-route__form-summary-total-results">' + totalFilteredStops + ' Result</p>');
        $($asideTotalStops).prepend('<span class="filtered-stop-results">Showing<span class="total-stops">' + totalFilteredStops + '</span>of</span>');
        $resultsContainer.addClass('js-active');
      }
      else if (totalFilteredStops > 1 && (categories.length > 0 || cityId !== null)) {
        $($resultsCount).html(totalFilteredStops + ' Results');
        // $($resultsCategoryContainer).prepend('<p class="component-route__form-summary-total-results">' + totalFilteredStops + ' Results</p>');
        $($asideTotalStops).prepend('<span class="filtered-stop-results">Showing <span class="total-stops">' + totalFilteredStops + '</span> of </span>');
        $resultsContainer.addClass('js-active');
      }
    },

    /**
     * Initialize Mobile Filters
     *
     * @param {jQuery} $routeElement
     *   The Route jQuery element.
     *
     */
    initializeMobileFilters: function ($routeElement) {
      var routeFilter = $routeElement.find('.pselect-wrapper[data-filter-name="route"]');
      var locationTypeFilter = $routeElement.find('.poptions__display-value[data-filter-name="location-type"]');
      var locationFilter = $routeElement.find('.pselect-wrapper[data-filter-name="location"]');

      if (window.matchMedia('(max-width: 768px)').matches) {
        routeFilter.addClass('mobile-filter-trigger');
        locationTypeFilter.addClass('mobile-filter-trigger');
        locationFilter.addClass('mobile-filter-trigger');
      }
      else {
        $routeElement.find('.modal').removeClass('js-active');
        $('body').removeClass('modal-active');
        routeFilter.removeClass('mobile-filter-trigger');
        locationTypeFilter.removeClass('mobile-filter-trigger');
        locationFilter.removeClass('mobile-filter-trigger');
      }
    },

    /**
     * Mobile Filter Click Events
     *
     * @param {jQuery} $routeElement
     *   The Route jQuery element.
     *
     */
    mobileFilterClickEvents: function ($routeElement) {
      var routeMobileFilterTrigger = $routeElement.find('.mobile-filter-trigger[data-filter-name="route"]');
      var mobileRouteFilterModal = $routeElement.find('.modal[data-filter-name="route"]');

      var locationTypeMobileFilterTrigger = $routeElement.find('.mobile-filter-trigger[data-filter-name="location-type"]');
      var mobileLocationTypeFilterModal = $routeElement.find('.modal[data-filter-name="location-type"]');
      var intiialFilterCategories = [];

      var locationMobileFilterTrigger = $routeElement.find('.mobile-filter-trigger[data-filter-name="location"]');
      var mobileLocationFilterModal = $routeElement.find('.modal[data-filter-name="location"]');

      if (window.matchMedia('(max-width: 768px)').matches) {
        $(routeMobileFilterTrigger).click(function () {
          if ($(routeMobileFilterTrigger).hasClass('mobile-filter-trigger')) {
            // Display Mobile Filter Modal
            $(mobileRouteFilterModal).addClass('js-active');
            $('body').addClass('modal-active');
          }
        });

        $(mobileRouteFilterModal).find('.close').click(function () {
          // Hide Mobile Filter Modal
          $(mobileRouteFilterModal).removeClass('js-active');
          $('body').removeClass('modal-active');
        });

        $(locationTypeMobileFilterTrigger).click(function () {
          if ($(locationTypeMobileFilterTrigger).hasClass('mobile-filter-trigger')) {
            // Display Mobile Filter Modal
            $(mobileLocationTypeFilterModal).addClass('js-active');
            $('body').addClass('modal-active');
          }
        });

        $(mobileLocationTypeFilterModal).find('.close').click(function () {
          // Hide Mobile Filter Modal
          $(mobileLocationTypeFilterModal).removeClass('js-active');
          $('body').removeClass('modal-active');
        });

        $(mobileLocationTypeFilterModal).find('.tmp-location-type-filter__apply-filter-btn').click(function () {
          // Hide Mobile Filter Modal
          $(mobileLocationTypeFilterModal).removeClass('js-active');
          $('body').removeClass('modal-active');
        });

        $(locationMobileFilterTrigger).click(function () {
          if ($(locationMobileFilterTrigger).hasClass('mobile-filter-trigger')) {
            // Display Mobile Filter Modal
            $(mobileLocationFilterModal).addClass('js-active');
            $('body').addClass('modal-active');
          }
        });

        $(mobileLocationFilterModal).find('.close').click(function () {
          // Hide Mobile Filter Modal
          $(mobileLocationFilterModal).removeClass('js-active');
          $('body').removeClass('modal-active');
        });

        $(mobileLocationFilterModal).find('.tmp-mobile-location-filter__apply-filter-btn').click(function () {
          // Hide Mobile Filter Modal
          $(mobileLocationFilterModal).removeClass('js-active');
          $('body').removeClass('modal-active');
        });

        // Initialize Location Type Mobile Filter
        if ($.urlParam('category') !== null) {
          intiialFilterCategories = $.urlParam('category').split(',');
          $(intiialFilterCategories).each(function (index, value) {
            $(mobileLocationTypeFilterModal).find('.form-checkbox[value=' + value + ']').prop('checked', 'true');
          });
        }

        // Click events for Mobile Location Type Filter
        $(mobileLocationTypeFilterModal).find('.form-checkbox').click(function () {
          var selectedLocationType = ($(this).val());
          var filterPlugin = $('.form-item-filter', $routeElement).data('pOptions');
          if ($(this).is(':checked')) {
            filterPlugin.select($(locationTypeMobileFilterTrigger).next().find('input[type=checkbox][value=' + selectedLocationType + ']'));
          }
          else {
            filterPlugin.unselect($(locationTypeMobileFilterTrigger).next().find('input[type=checkbox][value=' + selectedLocationType + ']'));
          }
        });

        // Mobile Location Filter
        $('input[data-drupal-selector=edit-mobile-search-by-city]').on('autocompleteclose', function (e) {
          var str = e.target.value;
          var textToDisplay = str.split(') ').pop();
          if (textToDisplay) {
            $(this).val(textToDisplay);
            $('input[data-drupal-selector=edit-going-city-search]', $routeElement).val(textToDisplay).autocomplete('search');
            $('input[data-drupal-selector=edit-going-city-search]', $routeElement).on('autocompleteopen', function (event, ui) {
              $(this).data('ui-autocomplete').menu.element.children().first().click();
              $(this).unbind('autocompleteopen');
            });
          }
        });

        $(mobileLocationFilterModal).find('.tmp-filter-options-wrapper__list-item').click(function () {
          var selectedLocation = $(this).data('area');
          $routeElement.find('.form-item-going').find('.pselect-item[data-filter-value=' + selectedLocation + ']').trigger('click');
        });

      }
    },

    /**
     * Update the main route filter based on the value in Drupal Settings
     *
     * @param {string} route
     * The Route Name.
     */
    updateMainRouteFilter: function (route) {
      // Update dropdown with Drupal Settings Value if they match the url param
      if (typeof drupalSettings.routeName !== 'undefined') {
        var routeName = drupalSettings.routeName;
        if (routeName.indexOf('?') > -1) {
          routeName = routeName.substring(0, routeName.indexOf('?'));
        }
        if (routeName === 'All') {
          routeName = 'All Routes';
        }
        // With addition of area regions, only set route select value if route or all routes.
        if (routeName.includes('Route')) {
          $('[data-filter-controller~="route"] a.pselect-display-value').html(routeName);
        }
        else if (routeName.includes('Area')) {
          var selectedRegion = $('[data-filter-controller~="location"] a.pselect-item:contains(' + routeName + ')');
          $('[data-filter-controller~="location"] a.pselect-display-value').html(selectedRegion.html());
        }
        delete drupalSettings.routeName;
      }
    },

    /**
     * Reset map bounds based on passed-in geolocations.
     *
     * @param {string} instanceId
     *   The Route instance ID.
     * @param {null|Object} geolocationGoing
     *   An object with lat and lng properties set. Null otherwise.
     * @param {null|Object} geolocationComing
     *   An object with lat and lng properties set. Null otherwise.
     * @param {null|Array} latLngArray
     *   An array with lat and lng properties set. Null otherwise.
     */
    positionMap: function (instanceId, geolocationGoing, geolocationComing, latLngArray) {
      // Get route map.
      var routeMap = Drupal.behaviors.componentRouteMap.getRouteMap(instanceId);

      // Initialize geolocation min and max values from sw and ne corners.
      var latMax = Drupal.behaviors.componentRouteMap.routeGeolocations.directions.ne.lat;
      var latMin = Drupal.behaviors.componentRouteMap.routeGeolocations.directions.sw.lat;
      var lngMax = Drupal.behaviors.componentRouteMap.routeGeolocations.directions.ne.lng;
      var lngMin = Drupal.behaviors.componentRouteMap.routeGeolocations.directions.sw.lng;
      var latPadding = 0;
      var lngPadding = 0;

      // If on mobile, position center of map based on coming, otherwise going.
      if ($('body').width() < 1024) {
        if (geolocationComing !== null) {
          // Set center of the map to coming.
          latMax = geolocationComing.lat;
          latMin = geolocationComing.lat;
          lngMax = geolocationComing.lng;
          lngMin = geolocationComing.lng;

          // Disable going parameter.
          geolocationGoing = null;

          // Set padding.
          latPadding = 0.05;
          lngPadding = 0.05;
        }
      }

      // If going is set, it is now the primary bounds object.
      if (geolocationGoing !== null) {
        // Reset geolocation min and max values to 'going' values.
        latMax = geolocationGoing.latMax;
        latMin = geolocationGoing.latMin;
        lngMax = geolocationGoing.lngMax;
        lngMin = geolocationGoing.lngMin;

        // If 'coming' is provided, modify relevant min/max values.
        if (geolocationComing !== null) {
          // Set padding to more-properly size padding around bounds.
          latPadding = 0.05;
          lngPadding = 0.05;

          // Reset either min or max lat.
          if (geolocationComing.lat < geolocationGoing.lat) {
            latMin = geolocationComing.lat;
          }
          else {
            latMax = geolocationComing.lat;
          }

          // Reset either min or max lng.
          if (geolocationComing.lng < geolocationGoing.lng) {
            lngMin = geolocationComing.lng;
          }
          else {
            lngMax = geolocationComing.lng;
          }
        }
      }

      // Increase values to give some padding around bounds.
      latMax += latPadding;
      latMin -= latPadding;
      lngMax += lngPadding;
      lngMin -= lngPadding;

      // Create bounds object.
      var bounds = new google.maps.LatLngBounds();

      // Auto center by marker points if available.
      if (geolocationGoing === null && latLngArray !== null) {
        for (var i = 0; i < latLngArray.length; i++) {
          bounds.extend(latLngArray[i]);
        }
      }
      else {
        // Add NW latlng bounds.
        bounds.extend(new google.maps.LatLng(latMax, lngMin));
        // Add SE latlng bounds.
        bounds.extend(new google.maps.LatLng(latMin, lngMax));
      }

      // Set bounds on map.
      routeMap.fitBounds(bounds);
    },

    /**
     * Gets a route jQuery element by instance ID.
     *
     * @param {string} instanceId
     *   The Route instance ID.
     *
     * @return {*|HTMLElement}
     *   The route element.
     */
    getRouteElement: function (instanceId) {
      return $('.component-route[data-instance-id=' + instanceId + ']');
    },

    /**
     * Gets a route ID by route instance ID.
     *
     * @param {string} instanceId
     *   The Route instance ID.
     *
     * @return {number}
     *   The route ID.
     */
    getRouteId: function (instanceId) {
      return Drupal.behaviors.componentRouteMap.getRouteElement(instanceId).data('route-id');
    },

    /**
     * Gets a route instance's map object.
     *
     * @param {string} instanceId
     *   The Route instance ID.
     *
     * @return {*}
     *   The google map object.
     */
    getRouteMap: function (instanceId) {
      return Drupal.behaviors.componentRouteMap.routeMaps[instanceId];
    },

    /**
     * Gets a route location marker for a specific route instance.
     *
     * @param {string} instanceId
     *   The Route instance ID.
     * @param {number} locationId
     *   The Route location ID.
     *
     * @return {*}
     *   The google map marker object.
     */
    getRouteMarker: function (instanceId, locationId) {
      return Drupal.behaviors.componentRouteMap.routeMapMarkers[instanceId][locationId];
    },

    /**
     * Gets a route location marker for a specific route instance.
     *
     * @param {string} instanceId
     *   The Route instance ID.
     * @param {number} locationId
     *   The Route location ID.
     *
     * @return {*}
     *   The google map marker object.
     */
    getRouteMarkerVisual: function (instanceId, locationId) {
      return Drupal.behaviors.componentRouteMap.routeMapMarkersVisual[instanceId][locationId];
    },

    /**
     * Gets a route location's data object.
     *
     * @param {string} routeId
     *   The Route ID.
     * @param {number} locationId
     *   The Route location ID.
     *
     * @return {Object}
     *   A route location's javascript object.
     */
    getRouteLocation: function (routeId, locationId) {
      return Drupal.behaviors.componentRouteMap.routeLocations[routeId][locationId];
    },

    /**
     * Gets a list of locations for a route.
     *
     * @param {string} routeId
     *   The Route ID.
     *
     * @return {Object}
     *   An array of route location objects, keyed by location ID.
     */
    getRouteLocations: function (routeId) {
      return Drupal.behaviors.componentRouteMap.routeLocations[routeId];
    }
  };

})(jQuery, Drupal, drupalSettings, once); // eslint-disable-line no-undef
